var ACTIVITY_FIELDS_LOGIC_ROLE;
(function (ACTIVITY_FIELDS_LOGIC_ROLE) {
  ACTIVITY_FIELDS_LOGIC_ROLE["ACCOUNT_EXECUTIVE"] = "ACTIVITY__ACCOUNT_EXECUTIVE";
  ACTIVITY_FIELDS_LOGIC_ROLE["AIRCALL_NOTE"] = "ACTIVITY__AIRCALL_NOTE";
  ACTIVITY_FIELDS_LOGIC_ROLE["ATTACHED_FILES"] = "ACTIVITY__ATTACHED_FILES";
  ACTIVITY_FIELDS_LOGIC_ROLE["CADENCE"] = "ACTIVITY__CADENCE";
  ACTIVITY_FIELDS_LOGIC_ROLE["CADENCE_TITLE"] = "ACTIVITY__CADENCE_TITLE";
  ACTIVITY_FIELDS_LOGIC_ROLE["CALENDAR_NOTE"] = "ACTIVITY__CALENDAR_NOTE";
  ACTIVITY_FIELDS_LOGIC_ROLE["CALL_DURATION"] = "ACTIVITY__CALL_DURATION";
  ACTIVITY_FIELDS_LOGIC_ROLE["CALL_LEAD_PHONE_NUMBER"] = "ACTIVITY__CALL_LEAD_PHONE_NUMBER";
  ACTIVITY_FIELDS_LOGIC_ROLE["CALL_RECORD_URL"] = "ACTIVITY__CALL_RECORD_URL";
  ACTIVITY_FIELDS_LOGIC_ROLE["CALL_RESULT"] = "ACTIVITY__CALL_RESULT";
  ACTIVITY_FIELDS_LOGIC_ROLE["COMPANY"] = "ACTIVITY__COMPANY";
  ACTIVITY_FIELDS_LOGIC_ROLE["CREATE_EVENT"] = "ACTIVITY__MEETING_CREATE_EVENT";
  ACTIVITY_FIELDS_LOGIC_ROLE["CREATION_DATETIME"] = "ACTIVITY__CREATION_DATETIME";
  ACTIVITY_FIELDS_LOGIC_ROLE["DATA_SOURCE"] = "ACTIVITY__DATA_SOURCE";
  ACTIVITY_FIELDS_LOGIC_ROLE["DIRECTION"] = "ACTIVITY__DIRECTION";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_HISTORY_CLICK"] = "ACTIVITY__EMAIL_HISTORY_CLICK";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_HISTORY_OPEN"] = "ACTIVITY__EMAIL_HISTORY_OPEN";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_LEAD"] = "ACTIVITY__EMAIL_LEAD";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_USER"] = "ACTIVITY__EMAIL_USER";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_METADATA"] = "ACTIVITY__EMAIL_METADATA";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_THREAD_ID"] = "ACTIVITY__EMAIL_THREAD_ID";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_TIMES_CLICKED"] = "ACTIVITY__EMAIL_TIMES_CLICK";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_TIMES_OPENED"] = "ACTIVITY__EMAIL_TIMES_OPEN";
  ACTIVITY_FIELDS_LOGIC_ROLE["EMAIL_TIMES_REPLIED"] = "ACTIVITY__EMAIL_TIMES_REPLY";
  ACTIVITY_FIELDS_LOGIC_ROLE["INBOUND_FORM_NAME"] = "ACTIVITY__INBOUND_FORM_NAME";
  ACTIVITY_FIELDS_LOGIC_ROLE["IS_AUTO_EMAIL"] = "ACTIVITY__IS_AUTOMATED_EMAIL";
  ACTIVITY_FIELDS_LOGIC_ROLE["IS_AUTOMATED_EMAIL"] = "ACTIVITY__IS_AUTOMATED_EMAIL";
  ACTIVITY_FIELDS_LOGIC_ROLE["IS_ATTEMPT"] = "ACTIVITY__IS_ATTEMPT";
  ACTIVITY_FIELDS_LOGIC_ROLE["IS_BOUNCED_EMAIL"] = "ACTIVITY__IS_BOUNCED_EMAIL";
  ACTIVITY_FIELDS_LOGIC_ROLE["IS_PINNED"] = "ACTIVITY__IS_PINNED";
  ACTIVITY_FIELDS_LOGIC_ROLE["IS_TOUCH"] = "ACTIVITY__IS_TOUCH";
  ACTIVITY_FIELDS_LOGIC_ROLE["LEAD"] = "ACTIVITY__LEAD";
  ACTIVITY_FIELDS_LOGIC_ROLE["LINKEDIN_THREAD"] = "ACTIVITY__LINKEDIN_THREAD";
  ACTIVITY_FIELDS_LOGIC_ROLE["MAIN_NOTE"] = "ACTIVITY__MAIN_NOTE";
  ACTIVITY_FIELDS_LOGIC_ROLE["MEETING_ASSIGNED_TO"] = "ACTIVITY__MEETING_ASSIGNED_TO";
  ACTIVITY_FIELDS_LOGIC_ROLE["MEETING_INVITEES"] = "ACTIVITY__MEETING_INVITEES";
  ACTIVITY_FIELDS_LOGIC_ROLE["MESSAGE_BODY"] = "ACTIVITY__MESSAGE_BODY";
  ACTIVITY_FIELDS_LOGIC_ROLE["MEETING_DURATION"] = "ACTIVITY__MEETING_DURATION";
  ACTIVITY_FIELDS_LOGIC_ROLE["MEETING_MAIN_TYPE"] = "ACTIVITY__MEETING_MAIN_TYPE";
  ACTIVITY_FIELDS_LOGIC_ROLE["MEETING_RESULT"] = "ACTIVITY__MEETING_RESULT";
  ACTIVITY_FIELDS_LOGIC_ROLE["MESSAGE_SUBJECT"] = "ACTIVITY__MESSAGE_SUBJECT";
  ACTIVITY_FIELDS_LOGIC_ROLE["NOTE"] = "ACTIVITY__NOTE";
  ACTIVITY_FIELDS_LOGIC_ROLE["OPPORTUNITY"] = "ACTIVITY__OPPORTUNITY";
  ACTIVITY_FIELDS_LOGIC_ROLE["PITCH_DONE"] = "ACTIVITY__PITCH_DONE";
  ACTIVITY_FIELDS_LOGIC_ROLE["PITCH"] = "ACTIVITY__PITCH";
  ACTIVITY_FIELDS_LOGIC_ROLE["REMINDER_TEMPLATE"] = "ACTIVITY__CALENDAR_REMINDER_TEMPLATE";
  ACTIVITY_FIELDS_LOGIC_ROLE["REPORTED"] = "ACTIVITY__REPORTED";
  ACTIVITY_FIELDS_LOGIC_ROLE["SALESFORCE_CAMPAIGN_ID"] = "SALESFORCE_CAMPAIGN_ID";
  ACTIVITY_FIELDS_LOGIC_ROLE["SALESFORCE_CAMPAIGN_MEMBER_ID"] = "SALESFORCE_CAMPAIGN_MEMBER_ID";
  ACTIVITY_FIELDS_LOGIC_ROLE["SID"] = "ACTIVITY__CALL_SID";
  ACTIVITY_FIELDS_LOGIC_ROLE["SOURCE"] = "ACTIVITY__DATA_SOURCE";
  ACTIVITY_FIELDS_LOGIC_ROLE["STATUS_TITLE"] = "ACTIVITY__STATUS_TITLE";
  ACTIVITY_FIELDS_LOGIC_ROLE["UNIQUE_NYLAS_ID"] = "ACTIVITY__EMAIL_UID";
  ACTIVITY_FIELDS_LOGIC_ROLE["USER"] = "ACTIVITY__USER";
  ACTIVITY_FIELDS_LOGIC_ROLE["TABLE_VIEW_ITEM"] = "ACTIVITY__TABLE_VIEW_ITEM";
  ACTIVITY_FIELDS_LOGIC_ROLE["TIME"] = "ACTIVITY__TIME";
  ACTIVITY_FIELDS_LOGIC_ROLE["TITLE"] = "ACTIVITY__MEETING_TITLE";
  ACTIVITY_FIELDS_LOGIC_ROLE["TYPE"] = "ACTIVITY__TYPE";
  ACTIVITY_FIELDS_LOGIC_ROLE["ATTACHMENTS"] = "ACTIVITY__ATTACHMENTS";
})(ACTIVITY_FIELDS_LOGIC_ROLE || (ACTIVITY_FIELDS_LOGIC_ROLE = {}));
var ACTIVITY_TYPES_VALUES_LOGIC_ROLE;
(function (ACTIVITY_TYPES_VALUES_LOGIC_ROLE) {
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["CADENCE"] = "ACTIVITY__TYPE_CADENCE";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["CALL"] = "ACTIVITY__TYPE__CALL";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["CHANGED_FROM"] = "ACTIVITY__TYPE_STATUS_CHANGED_FROM";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["CHANGED_TO"] = "ACTIVITY__TYPE_STATUS_CHANGED_TO";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["EMAIL"] = "ACTIVITY__TYPE__EMAIL";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["INBOUND"] = "ACTIVITY__TYPE__INBOUND";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["LINKEDIN"] = "ACTIVITY__TYPE__LINKEDIN_MESSAGE";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["MEETING"] = "ACTIVITY__TYPE__MEETING";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["NOTE"] = "ACTIVITY__TYPE__NOTE";
  ACTIVITY_TYPES_VALUES_LOGIC_ROLE["STATUS"] = "ACTIVITY__TYPE_STATUS";
})(ACTIVITY_TYPES_VALUES_LOGIC_ROLE || (ACTIVITY_TYPES_VALUES_LOGIC_ROLE = {}));
var CALL_RESULTS_LOGIC_ROLE;
(function (CALL_RESULTS_LOGIC_ROLE) {
  CALL_RESULTS_LOGIC_ROLE["CORRECT_CONTACT"] = "ACTIVITY__CALL_RESULT__CORRECT_CONTACT";
  CALL_RESULTS_LOGIC_ROLE["APPROACH"] = "ACTIVITY__CALL_RESULT__APPROACH";
  CALL_RESULTS_LOGIC_ROLE["GATEKEEPER"] = "ACTIVITY__CALL_RESULT__GATEKEEPER";
  CALL_RESULTS_LOGIC_ROLE["NO_ANSWER"] = "ACTIVITY__CALL_RESULT__NO_ANSWER";
  CALL_RESULTS_LOGIC_ROLE["WRONG_DATA"] = "ACTIVITY__CALL_RESULT__WRONG_DATA";
  CALL_RESULTS_LOGIC_ROLE["CALL_LATER"] = "ACTIVITY__CALL_RESULT__CALL_LATER";
})(CALL_RESULTS_LOGIC_ROLE || (CALL_RESULTS_LOGIC_ROLE = {}));
var ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE;
(function (ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE) {
  ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE["NO"] = "ACTIVITY__MAIN_NOTE__NO";
  ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE["YES"] = "ACTIVITY__MAIN_NOTE__YES";
})(ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE || (ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE = {}));
var PITCH_DONE_VALUES_LOGIC_ROLE;
(function (PITCH_DONE_VALUES_LOGIC_ROLE) {
  PITCH_DONE_VALUES_LOGIC_ROLE["NO"] = "ACTIVITY__PITCH_DONE__NO";
  PITCH_DONE_VALUES_LOGIC_ROLE["YES"] = "ACTIVITY__PITCH_DONE__YES";
})(PITCH_DONE_VALUES_LOGIC_ROLE || (PITCH_DONE_VALUES_LOGIC_ROLE = {}));
var IS_PINNED_VALUES_LOGIC_ROLE;
(function (IS_PINNED_VALUES_LOGIC_ROLE) {
  IS_PINNED_VALUES_LOGIC_ROLE["NO"] = "ACTIVITY__IS_PINNED__NO";
  IS_PINNED_VALUES_LOGIC_ROLE["YES"] = "ACTIVITY__IS_PINNED__YES";
})(IS_PINNED_VALUES_LOGIC_ROLE || (IS_PINNED_VALUES_LOGIC_ROLE = {}));
var BOUNCED_EMAIL_VALUES_LOGIC_ROLE;
(function (BOUNCED_EMAIL_VALUES_LOGIC_ROLE) {
  BOUNCED_EMAIL_VALUES_LOGIC_ROLE["NO"] = "ACTIVITY__IS_BOUNCED_EMAIL__NO";
  BOUNCED_EMAIL_VALUES_LOGIC_ROLE["YES"] = "ACTIVITY__IS_BOUNCED_EMAIL__YES";
})(BOUNCED_EMAIL_VALUES_LOGIC_ROLE || (BOUNCED_EMAIL_VALUES_LOGIC_ROLE = {}));
var MEETING_MAIN_TYPE_VALUES;
(function (MEETING_MAIN_TYPE_VALUES) {
  MEETING_MAIN_TYPE_VALUES["FIRST_MEETING"] = "ACTIVITY__MEETING_MAIN_TYPE__FIRST_MEETING";
  MEETING_MAIN_TYPE_VALUES["FOLLOW_UP"] = "ACTIVITY__MEETING_MAIN_TYPE__FOLLOW_UP";
})(MEETING_MAIN_TYPE_VALUES || (MEETING_MAIN_TYPE_VALUES = {}));
var ACTIVITY_MODE;
(function (ACTIVITY_MODE) {
  ACTIVITY_MODE["CREATE"] = "CREATE";
  ACTIVITY_MODE["EDIT"] = "EDIT";
})(ACTIVITY_MODE || (ACTIVITY_MODE = {}));
var CADENCE_TYPES_VALUES_LOGIC_ROLE;
(function (CADENCE_TYPES_VALUES_LOGIC_ROLE) {
  CADENCE_TYPES_VALUES_LOGIC_ROLE["CONFIGURE"] = "ACTIVITY__TYPE_CADENCE__CONFIGURED";
  CADENCE_TYPES_VALUES_LOGIC_ROLE["STARTED"] = "ACTIVITY__TYPE_CADENCE__STARTED";
  CADENCE_TYPES_VALUES_LOGIC_ROLE["ENDED"] = "ACTIVITY__TYPE_CADENCE__ENDED";
  CADENCE_TYPES_VALUES_LOGIC_ROLE["RESCHEDULE"] = "ACTIVITY__TYPE_CADENCE__RESCHEDULE";
  CADENCE_TYPES_VALUES_LOGIC_ROLE["STOPPED"] = "ACTIVITY__TYPE_CADENCE__STOPPED";
})(CADENCE_TYPES_VALUES_LOGIC_ROLE || (CADENCE_TYPES_VALUES_LOGIC_ROLE = {}));
var TYPES_STATUS_VALUES_LOGIC_ROLE;
(function (TYPES_STATUS_VALUES_LOGIC_ROLE) {
  TYPES_STATUS_VALUES_LOGIC_ROLE["COMPANY_STATUS_CHANGED"] = "ACTIVITY__TYPE_STATUS__COMPANY_STATUS_CHANGED";
  TYPES_STATUS_VALUES_LOGIC_ROLE["LEAD_STATUS_CHANGED"] = "ACTIVITY__TYPE_STATUS__LEAD_STATUS_CHANGED";
  TYPES_STATUS_VALUES_LOGIC_ROLE["NEW_LEAD_ADDED_TO_OPPORTUNITY"] = "ACTIVITY__TYPE_STATUS__NEW_LEAD_ADDED_TO_OPPORTUNITY";
  TYPES_STATUS_VALUES_LOGIC_ROLE["NEW_LEAD_CREATED"] = "ACTIVITY__TYPE_STATUS__NEW_LEAD_CREATED";
  TYPES_STATUS_VALUES_LOGIC_ROLE["OPPORTUNITY_ASSIGNED"] = "ACTIVITY__TYPE_STATUS__OPPORTUNITY_ASSIGNED";
  TYPES_STATUS_VALUES_LOGIC_ROLE["OPPORTUNITY_CREATED"] = "ACTIVITY__TYPE_STATUS__OPPORTUNITY_CREATED";
  TYPES_STATUS_VALUES_LOGIC_ROLE["OPPORTUNITY_STATUS_CHANGED"] = "ACTIVITY__TYPE_STATUS__OPPORTUNITY_STATUS_CHANGED";
})(TYPES_STATUS_VALUES_LOGIC_ROLE || (TYPES_STATUS_VALUES_LOGIC_ROLE = {}));
var REPORTED_VALUES_LOGIC_ROLE;
(function (REPORTED_VALUES_LOGIC_ROLE) {
  REPORTED_VALUES_LOGIC_ROLE["YES"] = "ACTIVITY__REPORTED__YES";
  REPORTED_VALUES_LOGIC_ROLE["NO"] = "ACTIVITY__REPORTED__NO";
})(REPORTED_VALUES_LOGIC_ROLE || (REPORTED_VALUES_LOGIC_ROLE = {}));
var IS_AUTOMATED_EMAIL_VALUES;
(function (IS_AUTOMATED_EMAIL_VALUES) {
  IS_AUTOMATED_EMAIL_VALUES["YES"] = "ACTIVITY__IS_AUTOMATED_EMAIL__YES";
  IS_AUTOMATED_EMAIL_VALUES["NO"] = "ACTIVITY__IS_AUTOMATED_EMAIL__NO";
})(IS_AUTOMATED_EMAIL_VALUES || (IS_AUTOMATED_EMAIL_VALUES = {}));
var DIRECTION_VALUES_LOGIC_ROLE;
(function (DIRECTION_VALUES_LOGIC_ROLE) {
  DIRECTION_VALUES_LOGIC_ROLE["OUTGOING"] = "ACTIVITY__DIRECTION__OUTGOING";
  DIRECTION_VALUES_LOGIC_ROLE["INCOMING"] = "ACTIVITY__DIRECTION__INCOMING";
  DIRECTION_VALUES_LOGIC_ROLE["MISSED"] = "ACTIVITY__DIRECTION__MISSED";
})(DIRECTION_VALUES_LOGIC_ROLE || (DIRECTION_VALUES_LOGIC_ROLE = {}));
var ACTIVITY_TYPES;
(function (ACTIVITY_TYPES) {
  ACTIVITY_TYPES["CADENCE"] = "Cadence";
  ACTIVITY_TYPES["CALL"] = "Call";
  ACTIVITY_TYPES["EMAIL"] = "Email";
  ACTIVITY_TYPES["INBOUND"] = "Inbound";
  ACTIVITY_TYPES["LINKEDIN"] = "LinkedIn Message";
  ACTIVITY_TYPES["MEETING"] = "Meeting";
  ACTIVITY_TYPES["NOTE"] = "Note";
  ACTIVITY_TYPES["STATUS"] = "Status";
})(ACTIVITY_TYPES || (ACTIVITY_TYPES = {}));
var ACTIVITY_DIRECTION;
(function (ACTIVITY_DIRECTION) {
  ACTIVITY_DIRECTION["INCOMING"] = "Incoming";
  ACTIVITY_DIRECTION["OUTGOING"] = "Outgoing";
  ACTIVITY_DIRECTION["MISSED"] = "Missed";
})(ACTIVITY_DIRECTION || (ACTIVITY_DIRECTION = {}));
var DATA_SOURCES;
(function (DATA_SOURCES) {
  DATA_SOURCES["WEB_APP"] = "DATA_SOURCE__WEB_APP";
  DATA_SOURCES["CHROME_EXTENSION"] = "DATA_SOURCE__LINKEDIN_CHROME_EXTENSION";
})(DATA_SOURCES || (DATA_SOURCES = {}));

var COMPANY_STATUS;
(function (COMPANY_STATUS) {
  COMPANY_STATUS["ACCOUNT"] = "ACCOUNT";
  COMPANY_STATUS["CONTACTED"] = "CONTACTED";
  COMPANY_STATUS["DISCARDED"] = "DISCARDED";
  COMPANY_STATUS["ENGAGED"] = "ENGAGED";
  COMPANY_STATUS["MEETING"] = "MEETING";
  COMPANY_STATUS["NURTURING"] = "NURTURING";
  COMPANY_STATUS["ON_PROSPECTION"] = "ON_PROSPECTION";
})(COMPANY_STATUS || (COMPANY_STATUS = {}));
var COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE;
(function (COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE) {
  COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE["ACTIVE"] = "COMPANY__SALES_STATUS__ACTIVE";
  COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE["ON_HOLD"] = "COMPANY__SALES_STATUS__ON_HOLD";
  COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE["NURTURING"] = "COMPANY__SALES_STATUS__NURTURING";
  COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE["DISCARDED"] = "COMPANY__SALES_STATUS__DISCARDED";
  COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE["CLIENT"] = "COMPANY__SALES_STATUS__CLIENT";
})(COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE || (COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE = {}));
var COMPANY_STATUS_LOGIC_ROLE;
(function (COMPANY_STATUS_LOGIC_ROLE) {
  COMPANY_STATUS_LOGIC_ROLE["NEW"] = "COMPANY__STATUS__NEW";
  COMPANY_STATUS_LOGIC_ROLE["BACKLOG"] = "COMPANY__STATUS__BACKLOG";
  COMPANY_STATUS_LOGIC_ROLE["DELIVERED"] = "COMPANY__STATUS__DELIVERED";
  COMPANY_STATUS_LOGIC_ROLE["ON_PROSPECTION"] = "COMPANY__STATUS__ON_PROSPECTION";
  COMPANY_STATUS_LOGIC_ROLE["CONTACTED"] = "COMPANY__STATUS__CONTACTED";
  COMPANY_STATUS_LOGIC_ROLE["ENGAGED"] = "COMPANY__STATUS__ENGAGED";
  COMPANY_STATUS_LOGIC_ROLE["MEETING"] = "COMPANY__STATUS__MEETING";
  COMPANY_STATUS_LOGIC_ROLE["NURTURING"] = "COMPANY__STATUS__NURTURING";
  COMPANY_STATUS_LOGIC_ROLE["ON_HOLD"] = "COMPANY__STATUS__ON_HOLD";
  COMPANY_STATUS_LOGIC_ROLE["DISCARDED"] = "COMPANY__STATUS__DISCARDED";
  COMPANY_STATUS_LOGIC_ROLE["ACCOUNT"] = "COMPANY__STATUS__ACCOUNT";
  COMPANY_STATUS_LOGIC_ROLE["CLIENT"] = "COMPANY__STATUS__CLIENT";
  COMPANY_STATUS_LOGIC_ROLE["FINDING_LEADS"] = "COMPANY__STATUS__FINDING_LEADS";
  COMPANY_STATUS_LOGIC_ROLE["READY_TO_PROSPECT"] = "COMPANY__STATUS__READY_TO_PROSPECT";
})(COMPANY_STATUS_LOGIC_ROLE || (COMPANY_STATUS_LOGIC_ROLE = {}));
var AVAILABLE_COMPANY_STATUS_LOGIC_ROLE;
(function (AVAILABLE_COMPANY_STATUS_LOGIC_ROLE) {
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["NEW"] = "COMPANY__STATUS__NEW";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["BACKLOG"] = "COMPANY__STATUS__BACKLOG";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["DELIVERED"] = "COMPANY__STATUS__DELIVERED";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["ON_PROSPECTION"] = "COMPANY__STATUS__ON_PROSPECTION";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["CONTACTED"] = "COMPANY__STATUS__CONTACTED";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["ENGAGED"] = "COMPANY__STATUS__ENGAGED";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["MEETING"] = "COMPANY__STATUS__MEETING";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["NURTURING"] = "COMPANY__STATUS__NURTURING";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["ON_HOLD"] = "COMPANY__STATUS__ON_HOLD";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["DISCARDED"] = "COMPANY__STATUS__DISCARDED";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["ACCOUNT"] = "COMPANY__STATUS__ACCOUNT";
  AVAILABLE_COMPANY_STATUS_LOGIC_ROLE["CLIENT"] = "COMPANY__STATUS__CLIENT";
})(AVAILABLE_COMPANY_STATUS_LOGIC_ROLE || (AVAILABLE_COMPANY_STATUS_LOGIC_ROLE = {}));
var COMPANY_STAGE_LOGIC_ROLE;
(function (COMPANY_STAGE_LOGIC_ROLE) {
  COMPANY_STAGE_LOGIC_ROLE["PROSPECT"] = "COMPANY__STAGE__PROSPECTING";
  COMPANY_STAGE_LOGIC_ROLE["SALES"] = "COMPANY__STAGE__SALES";
})(COMPANY_STAGE_LOGIC_ROLE || (COMPANY_STAGE_LOGIC_ROLE = {}));
var COMPANY_HIGH_PRIORITY_LOGIC_ROLE;
(function (COMPANY_HIGH_PRIORITY_LOGIC_ROLE) {
  COMPANY_HIGH_PRIORITY_LOGIC_ROLE["NO"] = "COMPANY__HIGH_PRIORITY__NO";
  COMPANY_HIGH_PRIORITY_LOGIC_ROLE["YES"] = "COMPANY__HIGH_PRIORITY__YES";
})(COMPANY_HIGH_PRIORITY_LOGIC_ROLE || (COMPANY_HIGH_PRIORITY_LOGIC_ROLE = {}));
var COMPANY_OPT_OUT_LOGIC_ROLE;
(function (COMPANY_OPT_OUT_LOGIC_ROLE) {
  COMPANY_OPT_OUT_LOGIC_ROLE["NO"] = "COMPANY__OPT_OUT__NO";
  COMPANY_OPT_OUT_LOGIC_ROLE["YES"] = "COMPANY__OPT_OUT__YES";
})(COMPANY_OPT_OUT_LOGIC_ROLE || (COMPANY_OPT_OUT_LOGIC_ROLE = {}));
var COMPANY_FIELDS_LOGIC_ROLE;
(function (COMPANY_FIELDS_LOGIC_ROLE) {
  COMPANY_FIELDS_LOGIC_ROLE["ASSIGNED_DATE"] = "COMPANY__LAST_ASSIGNED_DATE";
  COMPANY_FIELDS_LOGIC_ROLE["ASSIGNED_TO"] = "COMPANY__ASSIGNED_TO";
  COMPANY_FIELDS_LOGIC_ROLE["ATTEMPTS_COUNT"] = "COMPANY__ATTEMPTS_COUNT";
  COMPANY_FIELDS_LOGIC_ROLE["ATTEMPTS_LAST_DAY"] = "COMPANY__ATTEMPTS_LAST_DAY";
  COMPANY_FIELDS_LOGIC_ROLE["AUTHOR"] = "COMPANY__AUTHOR";
  COMPANY_FIELDS_LOGIC_ROLE["CADENCE_DATA"] = "COMPANY__CADENCE_DATA";
  COMPANY_FIELDS_LOGIC_ROLE["CADENCE_STOPPED"] = "COMPANY__CADENCE_STOPPED";
  COMPANY_FIELDS_LOGIC_ROLE["CADENCE"] = "COMPANY__CADENCE";
  COMPANY_FIELDS_LOGIC_ROLE["COMPANY_PARENT"] = "COMPANY__COMPANY_PARENT";
  COMPANY_FIELDS_LOGIC_ROLE["CONTAINS_INBOUND_LEAD"] = "COMPANY__CONTAINS_INBOUND_LEAD";
  COMPANY_FIELDS_LOGIC_ROLE["COUNTRY"] = "COMPANY__COUNTRY";
  COMPANY_FIELDS_LOGIC_ROLE["CREATION_DATETIME"] = "COMPANY__CREATION_DATETIME";
  COMPANY_FIELDS_LOGIC_ROLE["DISCARDED_REASONS"] = "COMPANY__DISCARDED_REASONS";
  COMPANY_FIELDS_LOGIC_ROLE["EMAIL"] = "COMPANY__EMAIL";
  COMPANY_FIELDS_LOGIC_ROLE["HAS_ATTEMPTS_AFTER_REASSIGN"] = "COMPANY__HAS_ATTEMPTS_AFTER_REASSIGN";
  COMPANY_FIELDS_LOGIC_ROLE["HIGH_PRIORITY"] = "COMPANY__HIGH_PRIORITY";
  COMPANY_FIELDS_LOGIC_ROLE["LINKEDIN_URL"] = "COMPANY__LINKEDIN_URL";
  COMPANY_FIELDS_LOGIC_ROLE["MR_RATING"] = "COMPANY__MR_RATING";
  COMPANY_FIELDS_LOGIC_ROLE["NAME"] = "COMPANY__NAME";
  COMPANY_FIELDS_LOGIC_ROLE["NUMBER_OF_LEADS"] = "COMPANY__LEADS_COUNT";
  COMPANY_FIELDS_LOGIC_ROLE["NURTURING_REASONS"] = "COMPANY__NURTURING_REASONS";
  COMPANY_FIELDS_LOGIC_ROLE["ON_HOLD_REASONS"] = "COMPANY__ON_HOLD_REASONS";
  COMPANY_FIELDS_LOGIC_ROLE["OPT_OUT"] = "COMPANY__OPT_OUT";
  COMPANY_FIELDS_LOGIC_ROLE["QQ_RATING"] = "COMPANY__QQ_RATING";
  COMPANY_FIELDS_LOGIC_ROLE["SALES_STATUS"] = "COMPANY__SALES_STATUS";
  COMPANY_FIELDS_LOGIC_ROLE["SALES_DISCARDED_REASONS"] = "COMPANY__SALES_DISCARDED_REASONS";
  COMPANY_FIELDS_LOGIC_ROLE["SALES_NURTURING_REASONS"] = "COMPANY__SALES_NURTURING_REASONS";
  COMPANY_FIELDS_LOGIC_ROLE["SALES_ON_HOLD_REASONS"] = "COMPANY__SALES_ON_HOLD_REASONS";
  COMPANY_FIELDS_LOGIC_ROLE["SCENARIO"] = "COMPANY__SCENARIO";
  COMPANY_FIELDS_LOGIC_ROLE["SOURCE"] = "COMPANY__SOURCE";
  COMPANY_FIELDS_LOGIC_ROLE["STAGE"] = "COMPANY__STAGE";
  COMPANY_FIELDS_LOGIC_ROLE["START_CADENCE"] = "COMPANY__START_CADENCE";
  COMPANY_FIELDS_LOGIC_ROLE["STATUS"] = "COMPANY__STATUS";
  COMPANY_FIELDS_LOGIC_ROLE["TARGET_MARKET"] = "COMPANY__TARGET_MARKET";
  COMPANY_FIELDS_LOGIC_ROLE["TIME_ZONE"] = "COMPANY__TIME_ZONE";
  COMPANY_FIELDS_LOGIC_ROLE["TOUCHES_COUNT"] = "COMPANY__TOUCHES_COUNT";
  COMPANY_FIELDS_LOGIC_ROLE["TOUCHES_LAST_DAY"] = "COMPANY__TOUCHES_LAST_DAY";
  COMPANY_FIELDS_LOGIC_ROLE["UPDATE_DATETIME"] = "COMPANY__UPDATE_DATETIME";
  COMPANY_FIELDS_LOGIC_ROLE["WEBSITE"] = "COMPANY__WEBSITE";
  COMPANY_FIELDS_LOGIC_ROLE["DATA_SOURCE_AUTOMATED"] = "COMPANY__DATA_SOURCE_AUTOMATED";
  COMPANY_FIELDS_LOGIC_ROLE["IS_INACTIVE"] = "COMPANY__IS_INACTIVE";
  COMPANY_FIELDS_LOGIC_ROLE["MAIN_NOTE"] = "COMPANY__MAIN_NOTE";
  COMPANY_FIELDS_LOGIC_ROLE["CADENCE_ENDED"] = "COMPANY__CADENCE_ENDED";
})(COMPANY_FIELDS_LOGIC_ROLE || (COMPANY_FIELDS_LOGIC_ROLE = {}));

var LEAD_STATUS;
(function (LEAD_STATUS) {
  LEAD_STATUS["MEETING"] = "MEETING";
  LEAD_STATUS["CONTACT"] = "CONTACT";
  LEAD_STATUS["DISCARDED"] = "DISCARDED";
  LEAD_STATUS["NURTURING"] = "NURTURING";
})(LEAD_STATUS || (LEAD_STATUS = {}));
var LEAD_STATUS_LOGIC_ROLE;
(function (LEAD_STATUS_LOGIC_ROLE) {
  LEAD_STATUS_LOGIC_ROLE["NEW"] = "LEAD__STATUS__NEW";
  LEAD_STATUS_LOGIC_ROLE["BACKLOG"] = "LEAD__STATUS__BACKLOG";
  LEAD_STATUS_LOGIC_ROLE["DELIVERED"] = "LEAD__STATUS__DELIVERED";
  LEAD_STATUS_LOGIC_ROLE["ON_PROSPECTION"] = "LEAD__STATUS__ON_PROSPECTION";
  LEAD_STATUS_LOGIC_ROLE["CONTACTED"] = "LEAD__STATUS__CONTACTED";
  LEAD_STATUS_LOGIC_ROLE["ENGAGED"] = "LEAD__STATUS__ENGAGED";
  LEAD_STATUS_LOGIC_ROLE["MEETING"] = "LEAD__STATUS__MEETING";
  LEAD_STATUS_LOGIC_ROLE["CONTACT"] = "LEAD__STATUS__CONTACT";
  LEAD_STATUS_LOGIC_ROLE["NURTURING"] = "LEAD__STATUS__NURTURING";
  LEAD_STATUS_LOGIC_ROLE["ON_HOLD"] = "LEAD__STATUS__ON_HOLD";
  LEAD_STATUS_LOGIC_ROLE["DISCARDED"] = "LEAD__STATUS__DISCARDED";
})(LEAD_STATUS_LOGIC_ROLE || (LEAD_STATUS_LOGIC_ROLE = {}));
var LEAD_SALES_STATUS_VALUES_LOGIC_ROLE;
(function (LEAD_SALES_STATUS_VALUES_LOGIC_ROLE) {
  LEAD_SALES_STATUS_VALUES_LOGIC_ROLE["ACTIVE"] = "LEAD__SALES_STATUS__ACTIVE";
  LEAD_SALES_STATUS_VALUES_LOGIC_ROLE["ON_HOLD"] = "LEAD__SALES_STATUS__ON_HOLD";
  LEAD_SALES_STATUS_VALUES_LOGIC_ROLE["NURTURING"] = "LEAD__SALES_STATUS__NURTURING";
  LEAD_SALES_STATUS_VALUES_LOGIC_ROLE["DISCARDED"] = "LEAD__SALES_STATUS__DISCARDED";
  LEAD_SALES_STATUS_VALUES_LOGIC_ROLE["CLIENT"] = "LEAD__SALES_STATUS__CLIENT";
})(LEAD_SALES_STATUS_VALUES_LOGIC_ROLE || (LEAD_SALES_STATUS_VALUES_LOGIC_ROLE = {}));
var LEAD_STAGE_LOGIC_ROLE;
(function (LEAD_STAGE_LOGIC_ROLE) {
  LEAD_STAGE_LOGIC_ROLE["PROSPECT"] = "LEAD__STAGE__PROSPECTING";
  LEAD_STAGE_LOGIC_ROLE["SALES"] = "LEAD__STAGE__SALES";
})(LEAD_STAGE_LOGIC_ROLE || (LEAD_STAGE_LOGIC_ROLE = {}));
var LEAD_FIELDS_LOGIC_ROLE;
(function (LEAD_FIELDS_LOGIC_ROLE) {
  LEAD_FIELDS_LOGIC_ROLE["ASSIGNED_DATE"] = "LEAD__LAST_ASSIGNED_DATE";
  LEAD_FIELDS_LOGIC_ROLE["ASSIGNED_TO"] = "LEAD__ASSIGNED_TO";
  LEAD_FIELDS_LOGIC_ROLE["ATTEMPTS_COUNT"] = "LEAD__ATTEMPTS_COUNT";
  LEAD_FIELDS_LOGIC_ROLE["ATTEMPTS_LAST_DAY"] = "LEAD__ATTEMPTS_LAST_DAY";
  LEAD_FIELDS_LOGIC_ROLE["AUTHOR"] = "LEAD__AUTHOR";
  LEAD_FIELDS_LOGIC_ROLE["BUYING_ROLE"] = "LEAD__BUYING_ROLE";
  LEAD_FIELDS_LOGIC_ROLE["CADENCE_DATA"] = "LEAD__CADENCE_DATA";
  LEAD_FIELDS_LOGIC_ROLE["CADENCE_STOPPED"] = "LEAD__CADENCE_STOPPED";
  LEAD_FIELDS_LOGIC_ROLE["CADENCE"] = "LEAD__CADENCE";
  LEAD_FIELDS_LOGIC_ROLE["COMPANY"] = "LEAD__COMPANY";
  LEAD_FIELDS_LOGIC_ROLE["CREATION_DATETIME"] = "LEAD__CREATION_DATETIME";
  LEAD_FIELDS_LOGIC_ROLE["DISCARDED_REASONS"] = "LEAD__DISCARDED_REASONS";
  LEAD_FIELDS_LOGIC_ROLE["EMAIL"] = "LEAD__EMAIL";
  LEAD_FIELDS_LOGIC_ROLE["FULL_NAME"] = "LEAD__FULL_NAME";
  LEAD_FIELDS_LOGIC_ROLE["FUNCTION"] = "";
  LEAD_FIELDS_LOGIC_ROLE["HIGH_PRIORITY"] = "LEAD__HIGH_PRIORITY";
  LEAD_FIELDS_LOGIC_ROLE["ICP"] = "LEAD__ICP";
  LEAD_FIELDS_LOGIC_ROLE["IS_MQL_OR_SAL_REQUIRED"] = "LEAD__IS_MQL_OR_SAL_REQUIRED";
  LEAD_FIELDS_LOGIC_ROLE["JOB_TITLE"] = "LEAD__LINKEDIN_JOB_TITLE";
  LEAD_FIELDS_LOGIC_ROLE["LEAD_OPPORTUNITIES"] = "LEAD__OPPORTUNITIES";
  LEAD_FIELDS_LOGIC_ROLE["LINKEDIN_JOB_TITLE"] = "LEAD__LINKEDIN_JOB_TITLE";
  LEAD_FIELDS_LOGIC_ROLE["LINKEDIN_URL"] = "LEAD__LINKEDIN_URL";
  LEAD_FIELDS_LOGIC_ROLE["SALES_NAV_URL"] = "LEAD__SALES_NAVIGATOR_URL";
  LEAD_FIELDS_LOGIC_ROLE["MR_RATING"] = "LEAD__MR_RATING";
  LEAD_FIELDS_LOGIC_ROLE["NAME"] = "LEAD__NAME";
  LEAD_FIELDS_LOGIC_ROLE["NURTURING_REASONS"] = "LEAD__NURTURING_REASONS";
  LEAD_FIELDS_LOGIC_ROLE["ON_HOLD_REASONS"] = "LEAD__ON_HOLD_REASONS";
  LEAD_FIELDS_LOGIC_ROLE["OPPORTUNITY"] = "LEAD__OPPORTUNITY";
  LEAD_FIELDS_LOGIC_ROLE["OPT_OUT"] = "LEAD__OPT_OUT";
  LEAD_FIELDS_LOGIC_ROLE["PHONE"] = "LEAD__PHONE";
  LEAD_FIELDS_LOGIC_ROLE["POSITION_ROLE"] = "LEAD__MANAGEMENT_LEVEL";
  LEAD_FIELDS_LOGIC_ROLE["SALES_DISCARDED_REASONS"] = "LEAD__SALES_DISCARDED_REASONS";
  LEAD_FIELDS_LOGIC_ROLE["SALES_NURTURING_REASONS"] = "LEAD__SALES_NURTURING_REASONS";
  LEAD_FIELDS_LOGIC_ROLE["SALES_ON_HOLD_REASONS"] = "LEAD__SALES_ON_HOLD_REASONS";
  LEAD_FIELDS_LOGIC_ROLE["SALES_STATUS"] = "LEAD__SALES_STATUS";
  LEAD_FIELDS_LOGIC_ROLE["SOURCE"] = "LEAD__SOURCE";
  LEAD_FIELDS_LOGIC_ROLE["STAGE"] = "LEAD__STAGE";
  LEAD_FIELDS_LOGIC_ROLE["START_CADENCE"] = "LEAD__START_CADENCE";
  LEAD_FIELDS_LOGIC_ROLE["STATUS"] = "LEAD__STATUS";
  LEAD_FIELDS_LOGIC_ROLE["TIME_ZONE"] = "LEAD__TIME_ZONE";
  LEAD_FIELDS_LOGIC_ROLE["TOUCHES_COUNT"] = "LEAD__TOUCHES_COUNT";
  LEAD_FIELDS_LOGIC_ROLE["TOUCHES_LAST_DAY"] = "LEAD__TOUCHES_LAST_DAY";
  LEAD_FIELDS_LOGIC_ROLE["UPDATE_DATETIME"] = "LEAD__UPDATE_DATETIME";
  LEAD_FIELDS_LOGIC_ROLE["MQL"] = "LEAD__MQL";
  LEAD_FIELDS_LOGIC_ROLE["SAL"] = "LEAD__SAL";
  LEAD_FIELDS_LOGIC_ROLE["IS_INACTIVE"] = "LEAD__IS_INACTIVE";
  LEAD_FIELDS_LOGIC_ROLE["MAIN_NOTE"] = "LEAD__MAIN_NOTE";
  LEAD_FIELDS_LOGIC_ROLE["SURNAME"] = "LEAD__SURNAME";
  LEAD_FIELDS_LOGIC_ROLE["CADENCE_ENDED"] = "LEAD__CADENCE_ENDED";
})(LEAD_FIELDS_LOGIC_ROLE || (LEAD_FIELDS_LOGIC_ROLE = {}));
var LEAD_IS_MQL_OR_SAL_LOGIC_ROLE;
(function (LEAD_IS_MQL_OR_SAL_LOGIC_ROLE) {
  LEAD_IS_MQL_OR_SAL_LOGIC_ROLE["YES"] = "LEAD__IS_MQL_OR_SAL_REQUIRED__YES";
  LEAD_IS_MQL_OR_SAL_LOGIC_ROLE["NO"] = "LEAD__IS_MQL_OR_SAL_REQUIRED__NO";
})(LEAD_IS_MQL_OR_SAL_LOGIC_ROLE || (LEAD_IS_MQL_OR_SAL_LOGIC_ROLE = {}));
var LEAD_HIGH_PRIORITY_LOGIC_ROLE;
(function (LEAD_HIGH_PRIORITY_LOGIC_ROLE) {
  LEAD_HIGH_PRIORITY_LOGIC_ROLE["YES"] = "LEAD__HIGH_PRIORITY_YES";
  LEAD_HIGH_PRIORITY_LOGIC_ROLE["NO"] = "LEAD__HIGH_PRIORITY_NO";
})(LEAD_HIGH_PRIORITY_LOGIC_ROLE || (LEAD_HIGH_PRIORITY_LOGIC_ROLE = {}));
var LEAD_OPT_OUT_LOGIC_ROLE;
(function (LEAD_OPT_OUT_LOGIC_ROLE) {
  LEAD_OPT_OUT_LOGIC_ROLE["YES"] = "LEAD__OPT_OUT__YES";
  LEAD_OPT_OUT_LOGIC_ROLE["NO"] = "LEAD__OPT_OUT__NO";
})(LEAD_OPT_OUT_LOGIC_ROLE || (LEAD_OPT_OUT_LOGIC_ROLE = {}));
var LEAD_CADENCE_STOPPED_LOGIC_ROLE;
(function (LEAD_CADENCE_STOPPED_LOGIC_ROLE) {
  LEAD_CADENCE_STOPPED_LOGIC_ROLE["YES"] = "LEAD__CADENCE_STOPPED_YES";
  LEAD_CADENCE_STOPPED_LOGIC_ROLE["NO"] = "LEAD__CADENCE_STOPPED_NO";
})(LEAD_CADENCE_STOPPED_LOGIC_ROLE || (LEAD_CADENCE_STOPPED_LOGIC_ROLE = {}));
var LEAD_SOURCE_LOGIC_ROLES;
(function (LEAD_SOURCE_LOGIC_ROLES) {
  LEAD_SOURCE_LOGIC_ROLES["INBOUND"] = "LEAD__SOURCE__INBOUND";
  LEAD_SOURCE_LOGIC_ROLES["OUTBOUND"] = "LEAD__SOURCE__OUTBOUND";
})(LEAD_SOURCE_LOGIC_ROLES || (LEAD_SOURCE_LOGIC_ROLES = {}));

var OPPORTUNITY_FIELDS_LOGIC_ROLE;
(function (OPPORTUNITY_FIELDS_LOGIC_ROLE) {
  OPPORTUNITY_FIELDS_LOGIC_ROLE["AMOUNT"] = "OPPORTUNITY__AMOUNT";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["ASSIGNED_TO"] = "OPPORTUNITY__ASSIGNED_TO";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["ASSIGNED_DATE"] = "OPPORTUNITY__LAST_ASSIGNED_DATE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["ATTEMPTS_LAST_DAY"] = "OPPORTUNITY__ATTEMPTS_LAST_DAY";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["AUTHOR"] = "OPPORTUNITY__AUTHOR";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["CADENCE_STOPPED"] = "OPPORTUNITY__CADENCE_STOPPED";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["CADENCE"] = "OPPORTUNITY__CADENCE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["CADENCE_DATA"] = "OPPORTUNITY__CADENCE_DATA";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["CLOSE_DATE"] = "OPPORTUNITY__CLOSE_DATE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["COMPANY"] = "OPPORTUNITY__COMPANY";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["CREATION_DATETIME"] = "OPPORTUNITY__CREATION_DATETIME";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["LEADS_COUNT"] = "OPPORTUNITY__LEADS_COUNT";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["NAME"] = "OPPORTUNITY__NAME";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["OPT_OUT"] = "OPPORTUNITY__OPT_OUT";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["PRIMARY_CONTACT"] = "OPPORTUNITY__LEAD_PRIMARY_CONTACT";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["START_CADENCE"] = "OPPORTUNITY__START_CADENCE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["STATUS__CLOSED_LOST"] = "OPPORTUNITY__STATUS__CLOSED_LOST";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["STATUS__CLOSED_WIN_DATE"] = "OPPORTUNITY__STATUS__CLOSED_WIN_DATE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["STATUS__CLOSED_WIN"] = "OPPORTUNITY__STATUS__CLOSED_WIN";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["STATUS__LAST_UPDATE"] = "OPPORTUNITY__STATUS__LAST_UPDATE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["STATUS"] = "OPPORTUNITY__STATUS";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["TYPE"] = "OPPORTUNITY__TYPE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["WITHOUT_FUTURE_TASKS"] = "OPPORTUNITY__WITHOUT_FUTURE_TASKS";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["UPDATE_DATETIME"] = "OPPORTUNITY__UPDATE_DATETIME";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["CLOSED_LOST_REASON"] = "OPPORTUNITY__CLOSED_LOST_REASON";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["EXTRA_INFO_ACTIVITY_DATE"] = "OPPORTUNITY__INFO_ACTIVITY_DATE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["EXTRA_INFO_ACTIVITY"] = "OPPORTUNITY__INFO_ACTIVITY_TYPE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["EXTRA_INFO_TASK_DATE"] = "OPPORTUNITY__INFO_TASK_DATE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["IS_INACTIVE"] = "OPPORTUNITY__IS_INACTIVE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["MAIN_NOTE"] = "OPPORTUNITY__MAIN_NOTE";
  OPPORTUNITY_FIELDS_LOGIC_ROLE["CADENCE_ENDED"] = "OPPORTUNITY__CADENCE_ENDED";
})(OPPORTUNITY_FIELDS_LOGIC_ROLE || (OPPORTUNITY_FIELDS_LOGIC_ROLE = {}));
var OPPORTUNITY_STATUS_LOGIC_ROLE;
(function (OPPORTUNITY_STATUS_LOGIC_ROLE) {
  OPPORTUNITY_STATUS_LOGIC_ROLE["CLOSED_LOST"] = "OPPORTUNITY__STATUS__CLOSED_LOST";
  OPPORTUNITY_STATUS_LOGIC_ROLE["CLOSED_WON"] = "OPPORTUNITY__STATUS__CLOSED_WON";
})(OPPORTUNITY_STATUS_LOGIC_ROLE || (OPPORTUNITY_STATUS_LOGIC_ROLE = {}));
var OPPORTUNITY_OPT_OUT_LOGIC_ROLE;
(function (OPPORTUNITY_OPT_OUT_LOGIC_ROLE) {
  OPPORTUNITY_OPT_OUT_LOGIC_ROLE["YES"] = "OPPORTUNITY__OPT_OUT__YES";
  OPPORTUNITY_OPT_OUT_LOGIC_ROLE["NO"] = "OPPORTUNITY__OPT_OUT__NO";
})(OPPORTUNITY_OPT_OUT_LOGIC_ROLE || (OPPORTUNITY_OPT_OUT_LOGIC_ROLE = {}));
var OPPORTUNITY_LEADS_LOGIC_ROLES;
(function (OPPORTUNITY_LEADS_LOGIC_ROLES) {
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_PRIMARY_CONTACT"] = "OPPORTUNITY__LEAD_PRIMARY_CONTACT";
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_USER"] = "OPPORTUNITY__LEAD_USER";
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_INFLUENCER"] = "OPPORTUNITY__LEAD_INFLUENCER";
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_DECISION_MAKER"] = "OPPORTUNITY__LEAD_DECISION_MAKER";
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_APPROVER"] = "OPPORTUNITY__LEAD_APPROVER";
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_BUYER"] = "OPPORTUNITY__LEAD_BUYER";
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_GATEKEEPER"] = "OPPORTUNITY__LEAD_GATEKEEPER";
  OPPORTUNITY_LEADS_LOGIC_ROLES["OPPORTUNITY__LEAD_OTHER"] = "OPPORTUNITY__LEAD_OTHER";
})(OPPORTUNITY_LEADS_LOGIC_ROLES || (OPPORTUNITY_LEADS_LOGIC_ROLES = {}));
var OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME;
(function (OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME) {
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__OUTGOING_CALL"] = "Outgoing call";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__INCOMING_CALL"] = "Incoming call";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__MISSED_CALL"] = "Missed call";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__EMAIL_SENT"] = "Email sent";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__EMAIL_RECEIVED"] = "Email received";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__LINKEDIN_MESSAGE_SENT"] = "LinkedIn message sent";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__LINKEDIN_MESSAGE_RECEIVED"] = "LinkedIn message received";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__CADENCE_ENDED"] = "Cadence ended";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__CADENCE_STARTED"] = "Cadence started";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__INBOUND_ACTIVITY"] = "Inbound activity";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__INBOUND_LEAD"] = "Inbound lead";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__MEETING_CREATED"] = "Meeting created";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__MEETING_DONE"] = "Meeting done";
  OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME["OPPORTUNITY__INFO_TYPE__NEXT_TASK"] = "Tasks";
})(OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME || (OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME = {}));

var OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE;
(function (OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE) {
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["AUTHOR"] = "OPPORTUNITY_PRODUCT__AUTHOR";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["DISCOUNT"] = "OPPORTUNITY_PRODUCT__DISCOUNT";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["EXTRA_FEE"] = "OPPORTUNITY_PRODUCT__EXTRA_FEE";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["OPPORTUNITY"] = "OPPORTUNITY_PRODUCT__OPPORTUNITY";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["PRICE"] = "OPPORTUNITY_PRODUCT__PRICE";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["PRODUCT"] = "OPPORTUNITY_PRODUCT__PRODUCT";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["TOTAL_PRICE"] = "OPPORTUNITY_PRODUCT__TOTAL_PRICE";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["UNITS"] = "OPPORTUNITY_PRODUCT__UNITS";
  OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE["VAT"] = "OPPORTUNITY_PRODUCT__VAT";
})(OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE || (OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE = {}));

var PRODUCT_FIELDS_LOGIC_ROLE;
(function (PRODUCT_FIELDS_LOGIC_ROLE) {
  PRODUCT_FIELDS_LOGIC_ROLE["CATEGORY"] = "PRODUCT__CATEGORY";
  PRODUCT_FIELDS_LOGIC_ROLE["NAME"] = "PRODUCT__NAME";
  PRODUCT_FIELDS_LOGIC_ROLE["PRICE"] = "PRODUCT__PRICE";
  PRODUCT_FIELDS_LOGIC_ROLE["VAT"] = "PRODUCT__VAT";
  PRODUCT_FIELDS_LOGIC_ROLE["SALESFORCE_PRICEBOOK_ID"] = "PRODUCT__SALESFORCE_PRICEBOOK_ID";
  PRODUCT_FIELDS_LOGIC_ROLE["SALESFORCE_PRICEBOOK_ENTRY_ID"] = "PRODUCT__SALESFORCE_PRICEBOOK_ENTRY_ID";
  PRODUCT_FIELDS_LOGIC_ROLE["SALESFORCE_PRODUCT_ID"] = "PRODUCT__SALESFORCE_PRODUCT_ID";
})(PRODUCT_FIELDS_LOGIC_ROLE || (PRODUCT_FIELDS_LOGIC_ROLE = {}));

var TaskTypeName;
(function (TaskTypeName) {
  TaskTypeName["ProspectCadence"] = "Prospect Cadence";
  TaskTypeName["NextStep"] = "Next Step";
  TaskTypeName["ContactBeforeMeeting"] = "Contact before meeting";
})(TaskTypeName || (TaskTypeName = {}));
var TasksHookFamilies;
(function (TasksHookFamilies) {
  TasksHookFamilies["Calendar"] = "Calendar";
  TasksHookFamilies["Home"] = "Home";
})(TasksHookFamilies || (TasksHookFamilies = {}));
var TASK_AUTOMATED_STATUS_LOGIC_ROLE;
(function (TASK_AUTOMATED_STATUS_LOGIC_ROLE) {
  TASK_AUTOMATED_STATUS_LOGIC_ROLE["PENDING"] = "TASK__AUTOMATED_STATUS__PENDING";
  TASK_AUTOMATED_STATUS_LOGIC_ROLE["COMPLETED"] = "TASK__AUTOMATED_STATUS__COMPLETED";
  TASK_AUTOMATED_STATUS_LOGIC_ROLE["FAILED"] = "TASK__AUTOMATED_STATUS__FAILED";
  TASK_AUTOMATED_STATUS_LOGIC_ROLE["PAUSED"] = "TASK__AUTOMATED_STATUS__PAUSED";
  TASK_AUTOMATED_STATUS_LOGIC_ROLE["RESCHEDULED"] = "TASK__AUTOMATED_STATUS__RESCHEDULED";
})(TASK_AUTOMATED_STATUS_LOGIC_ROLE || (TASK_AUTOMATED_STATUS_LOGIC_ROLE = {}));
var TASK_AUTOMATED_ERROR_LOGIC_ROLE;
(function (TASK_AUTOMATED_ERROR_LOGIC_ROLE) {
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["MISSING_EMAIL"] = "TASK__AUTOMATION_ERROR__MISSING_EMAIL";
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["OPT_OUT_ENABLED"] = "TASK__AUTOMATION_ERROR__OPT_OUT_ENABLED";
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["PAUSED_MORE_THAN_7_DAYS"] = "TASK__AUTOMATION_ERROR__PAUSED_MORE_THAN_7_DAYS";
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["STOPPED_ACCOUNT"] = "TASK__AUTOMATION_ERROR__STOPPED_ACCOUNT";
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["UNKNOWN_ERROR"] = "TASK__AUTOMATION_ERROR__UNKNOWN_ERROR";
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["VARIABLE_NOT_RESOLVED"] = "TASK__AUTOMATION_ERROR__MISSING_VARIABLE";
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["DAILY_LIMIT_EXCEEDED"] = "TASK__AUTOMATION_ERROR__DAILY_LIMIT_EXCEEDED";
  TASK_AUTOMATED_ERROR_LOGIC_ROLE["INVALID_RECIPIENT"] = "TASK__AUTOMATION_ERROR__INVALID_RECIPIENT";
})(TASK_AUTOMATED_ERROR_LOGIC_ROLE || (TASK_AUTOMATED_ERROR_LOGIC_ROLE = {}));
var TASK_AUTOMATED_PAUSED_REASONS_LOGIC_ROLE;
(function (TASK_AUTOMATED_PAUSED_REASONS_LOGIC_ROLE) {
  TASK_AUTOMATED_PAUSED_REASONS_LOGIC_ROLE["OVERDUE"] = "TASK__AUTOMATION_PAUSE_REASON__OVERDUE";
  TASK_AUTOMATED_PAUSED_REASONS_LOGIC_ROLE["TOUCH"] = "TASK__AUTOMATION_PAUSE_REASON__TOUCH";
})(TASK_AUTOMATED_PAUSED_REASONS_LOGIC_ROLE || (TASK_AUTOMATED_PAUSED_REASONS_LOGIC_ROLE = {}));
var TASK_FIELDS_LOGIC_ROLE;
(function (TASK_FIELDS_LOGIC_ROLE) {
  TASK_FIELDS_LOGIC_ROLE["ASSIGNED_TO"] = "TASK__ASSIGNED_TO";
  TASK_FIELDS_LOGIC_ROLE["AUTOMATED_STATUS"] = "TASK__AUTOMATED_STATUS";
  TASK_FIELDS_LOGIC_ROLE["AUTOMATION_ERROR"] = "TASK__AUTOMATION_ERROR";
  TASK_FIELDS_LOGIC_ROLE["AUTOMATION_PAUSE_REASON"] = "TASK__AUTOMATION_PAUSE_REASON";
  TASK_FIELDS_LOGIC_ROLE["CADENCE"] = "TASK__CADENCE";
  TASK_FIELDS_LOGIC_ROLE["COMPANY"] = "TASK__COMPANY";
  TASK_FIELDS_LOGIC_ROLE["COMPLETED_DATE"] = "TASK__COMPLETED_DATE";
  TASK_FIELDS_LOGIC_ROLE["CREATION_DATETIME"] = "TASK__CREATION_DATETIME";
  TASK_FIELDS_LOGIC_ROLE["DESCRIPTION"] = "TASK__DESCRIPTION";
  TASK_FIELDS_LOGIC_ROLE["EMAIL_METADATA"] = "TASK__EMAIL_METADATA";
  TASK_FIELDS_LOGIC_ROLE["IS_AUTOMATED"] = "TASK__IS_AUTOMATED";
  TASK_FIELDS_LOGIC_ROLE["LEAD"] = "TASK__LEAD";
  TASK_FIELDS_LOGIC_ROLE["OPPORTUNITY"] = "TASK__OPPORTUNITY";
  TASK_FIELDS_LOGIC_ROLE["SCHEDULED_DATE"] = "TASK__SCHEDULED_DATE";
  TASK_FIELDS_LOGIC_ROLE["SCHEDULED_DATETIME"] = "TASK__SCHEDULED_DATETIME";
  TASK_FIELDS_LOGIC_ROLE["STATUS"] = "TASK__STATUS";
  TASK_FIELDS_LOGIC_ROLE["TASK_TYPE"] = "TASK__TASK_TYPE";
  TASK_FIELDS_LOGIC_ROLE["TITLE"] = "TASK__TITLE";
  TASK_FIELDS_LOGIC_ROLE["UPDATE_DATETIME"] = "TASK__UPDATE_DATETIME";
  TASK_FIELDS_LOGIC_ROLE["AUTOMATED_EMAIL_TO"] = "TASK__AUTOMATED_EMAIL_TO";
  TASK_FIELDS_LOGIC_ROLE["IS_AUTOMATED_EMAIL"] = "TASK__IS_ACTION_AUTOMATED_EMAIL";
  TASK_FIELDS_LOGIC_ROLE["IS_ACTION_CALL"] = "TASK__IS_ACTION_CALL";
  TASK_FIELDS_LOGIC_ROLE["IS_ACTION_EMAIL"] = "TASK__IS_ACTION_EMAIL";
  TASK_FIELDS_LOGIC_ROLE["IS_ACTION_LINKEDIN"] = "TASK__IS_ACTION_LINKEDIN_MESSAGE";
  TASK_FIELDS_LOGIC_ROLE["MEETING_ACTIVITY"] = "TASK__ACTIVITY_MEETING";
  TASK_FIELDS_LOGIC_ROLE["TEMPLATE"] = "TASK__TEMPLATE_ID";
  TASK_FIELDS_LOGIC_ROLE["CUSTOM_TASK"] = "TASK__CUSTOM_TASK";
})(TASK_FIELDS_LOGIC_ROLE || (TASK_FIELDS_LOGIC_ROLE = {}));
var TASK_ACTION;
(function (TASK_ACTION) {
  TASK_ACTION["CALL"] = "TASK__IS_ACTION_CALL";
  TASK_ACTION["EMAIL"] = "TASK__IS_ACTION_EMAIL";
  TASK_ACTION["LINKEDIN_MESSAGE"] = "TASK__IS_ACTION_LINKEDIN_MESSAGE";
  TASK_ACTION["AUTOMATED_EMAIL"] = "TASK__IS_ACTION_AUTOMATED_EMAIL";
})(TASK_ACTION || (TASK_ACTION = {}));
var TASK_ACTION_VALUE;
(function (TASK_ACTION_VALUE) {
  TASK_ACTION_VALUE["CALL_YES"] = "TASK__IS_ACTION_CALL__YES";
  TASK_ACTION_VALUE["EMAIL_YES"] = "TASK__IS_ACTION_EMAIL__YES";
  TASK_ACTION_VALUE["LINKEDIN_MESSAGE_YES"] = "TASK__IS_ACTION_LINKEDIN_MESSAGE__YES";
  TASK_ACTION_VALUE["AUTOMATED_EMAIL_YES"] = "TASK__IS_ACTION_AUTOMATED_EMAIL__YES";
  TASK_ACTION_VALUE["AUTOMATED_EMAIL_NO"] = "TASK__IS_ACTION_AUTOMATED_EMAIL__NO";
})(TASK_ACTION_VALUE || (TASK_ACTION_VALUE = {}));
var TASK_AUTOMATED_VALUE;
(function (TASK_AUTOMATED_VALUE) {
  TASK_AUTOMATED_VALUE["AUTOMATED_YES"] = "TASK__IS_AUTOMATED__YES";
})(TASK_AUTOMATED_VALUE || (TASK_AUTOMATED_VALUE = {}));
var TASK_STATUS_VALUE_LOGIC_ROLE;
(function (TASK_STATUS_VALUE_LOGIC_ROLE) {
  TASK_STATUS_VALUE_LOGIC_ROLE["COMPLETED_OVERDUE"] = "TASK__STATUS__COMPLETED_OVERDUE";
  TASK_STATUS_VALUE_LOGIC_ROLE["COMPLETED"] = "TASK__STATUS__COMPLETED";
  TASK_STATUS_VALUE_LOGIC_ROLE["OVERDUE"] = "TASK__STATUS__OVERDUE";
  TASK_STATUS_VALUE_LOGIC_ROLE["REJECTED"] = "TASK__STATUS__REJECTED";
  TASK_STATUS_VALUE_LOGIC_ROLE["TODO"] = "TASK__STATUS__TODO";
})(TASK_STATUS_VALUE_LOGIC_ROLE || (TASK_STATUS_VALUE_LOGIC_ROLE = {}));
var TASK_TYPE;
(function (TASK_TYPE) {
  TASK_TYPE["ADD_LEADS_TO_QC"] = "ADD_LEADS_TO_QC";
  TASK_TYPE["CONTACT_BEFORE_MEETING"] = "CONTACT_BEFORE_MEETING";
  TASK_TYPE["MEETING"] = "MEETING";
  TASK_TYPE["NEXT_STEP"] = "NEXT_STEP";
  TASK_TYPE["PROSPECT_CADENCE"] = "PROSPECT_CADENCE";
  TASK_TYPE["START_CADENCE"] = "START_CADENCE";
  TASK_TYPE["SCHEDULED_EMAIL"] = "SCHEDULED_EMAIL";
})(TASK_TYPE || (TASK_TYPE = {}));

var _STAGE_VALUES_LOGIC_R, _Object$freeze, _FIELDS_LOGIC_ROLE, _Object$freeze2, _Object$freeze3;
function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var BobjectTypes;
(function (BobjectTypes) {
  BobjectTypes["Company"] = "Company";
  BobjectTypes["Lead"] = "Lead";
  BobjectTypes["Opportunity"] = "Opportunity";
  BobjectTypes["Task"] = "Task";
  BobjectTypes["Activity"] = "Activity";
})(BobjectTypes || (BobjectTypes = {}));
var BOBJECT_TYPES;
(function (BOBJECT_TYPES) {
  BOBJECT_TYPES["ACTIVITY"] = "Activity";
  BOBJECT_TYPES["COMPANY"] = "Company";
  BOBJECT_TYPES["LEAD"] = "Lead";
  BOBJECT_TYPES["OPPORTUNITY"] = "Opportunity";
  BOBJECT_TYPES["TASK"] = "Task";
  BOBJECT_TYPES["OPPORTUNITY_PRODUCT"] = "OpportunityProduct";
  BOBJECT_TYPES["PRODUCT"] = "Product";
})(BOBJECT_TYPES || (BOBJECT_TYPES = {}));
var PluralBobjectTypes;
(function (PluralBobjectTypes) {
  PluralBobjectTypes["Company"] = "Companies";
  PluralBobjectTypes["Lead"] = "Leads";
  PluralBobjectTypes["Activity"] = "Activities";
  PluralBobjectTypes["Task"] = "Tasks";
  PluralBobjectTypes["Opportunity"] = "Opportunities";
  PluralBobjectTypes["Product"] = "Products";
  PluralBobjectTypes["OpportunityProduct"] = "Opportunity products";
})(PluralBobjectTypes || (PluralBobjectTypes = {}));
var SingularFromPluralBobjectTypes;
(function (SingularFromPluralBobjectTypes) {
  SingularFromPluralBobjectTypes["Companies"] = "Company";
  SingularFromPluralBobjectTypes["Leads"] = "Lead";
  SingularFromPluralBobjectTypes["Activities"] = "Activity";
  SingularFromPluralBobjectTypes["Tasks"] = "Task";
  SingularFromPluralBobjectTypes["Opportunities"] = "Opportunity";
})(SingularFromPluralBobjectTypes || (SingularFromPluralBobjectTypes = {}));
function isBobject(bobject) {
  return bobject && bobject.id && bobject.fields;
}
var STAGE_VALUES_LOGIC_ROLES = (_STAGE_VALUES_LOGIC_R = {}, _defineProperty$1(_STAGE_VALUES_LOGIC_R, BOBJECT_TYPES.COMPANY, COMPANY_STAGE_LOGIC_ROLE), _defineProperty$1(_STAGE_VALUES_LOGIC_R, BOBJECT_TYPES.LEAD, LEAD_STAGE_LOGIC_ROLE), _defineProperty$1(_STAGE_VALUES_LOGIC_R, BOBJECT_TYPES.OPPORTUNITY, OPPORTUNITY_STATUS_LOGIC_ROLE), _STAGE_VALUES_LOGIC_R);
var STATUS_VALUES_LOGIC_ROLES = Object.freeze((_Object$freeze = {}, _defineProperty$1(_Object$freeze, BOBJECT_TYPES.COMPANY, COMPANY_STATUS_LOGIC_ROLE), _defineProperty$1(_Object$freeze, BOBJECT_TYPES.LEAD, LEAD_STATUS_LOGIC_ROLE), _defineProperty$1(_Object$freeze, BOBJECT_TYPES.OPPORTUNITY, OPPORTUNITY_STATUS_LOGIC_ROLE), _Object$freeze));
var FIELDS_LOGIC_ROLE = (_FIELDS_LOGIC_ROLE = {}, _defineProperty$1(_FIELDS_LOGIC_ROLE, BOBJECT_TYPES.COMPANY, COMPANY_FIELDS_LOGIC_ROLE), _defineProperty$1(_FIELDS_LOGIC_ROLE, BOBJECT_TYPES.LEAD, LEAD_FIELDS_LOGIC_ROLE), _defineProperty$1(_FIELDS_LOGIC_ROLE, BOBJECT_TYPES.OPPORTUNITY, OPPORTUNITY_FIELDS_LOGIC_ROLE), _defineProperty$1(_FIELDS_LOGIC_ROLE, BOBJECT_TYPES.TASK, TASK_FIELDS_LOGIC_ROLE), _defineProperty$1(_FIELDS_LOGIC_ROLE, BOBJECT_TYPES.ACTIVITY, ACTIVITY_FIELDS_LOGIC_ROLE), _defineProperty$1(_FIELDS_LOGIC_ROLE, BOBJECT_TYPES.OPPORTUNITY_PRODUCT, OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE), _defineProperty$1(_FIELDS_LOGIC_ROLE, BOBJECT_TYPES.PRODUCT, PRODUCT_FIELDS_LOGIC_ROLE), _FIELDS_LOGIC_ROLE);
var SALES_STATUS_VALUES_LOGIC_ROLES = Object.freeze((_Object$freeze2 = {}, _defineProperty$1(_Object$freeze2, BOBJECT_TYPES.COMPANY, COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE), _defineProperty$1(_Object$freeze2, BOBJECT_TYPES.LEAD, LEAD_SALES_STATUS_VALUES_LOGIC_ROLE), _defineProperty$1(_Object$freeze2, BOBJECT_TYPES.OPPORTUNITY, OPPORTUNITY_STATUS_LOGIC_ROLE), _Object$freeze2));
var HUBSPOT = Object.freeze((_Object$freeze3 = {}, _defineProperty$1(_Object$freeze3, BOBJECT_TYPES.LEAD, 'HUBSPOT__CONTACT_ID'), _defineProperty$1(_Object$freeze3, BOBJECT_TYPES.COMPANY, 'HUBSPOT__COMPANY_ID'), _defineProperty$1(_Object$freeze3, BOBJECT_TYPES.OPPORTUNITY, 'HUBSPOT__DEAL_ID'), _Object$freeze3));

// eslint-disable-next-line prettier/prettier

var defaultSearchCompany = {
  attempts: 0,
  bobjectType: undefined,
  companyName: "",
  highlights: {},
  lastAttemptDate: "",
  lastTouchDate: "",
  numberOfLeads: 0,
  parentCompanyId: "",
  parentCompanyName: "",
  phoneNumbers: [],
  emails: [],
  rawBobject: {
    contents: {},
    id: undefined
  },
  stage: "",
  status: "",
  targetMarket: "",
  touches: 0,
  url: "",
  website: "",
  assignedTo: ""
};
var typeFilterConstants = ['All', 'Company', 'Lead', 'Opportunity'];

var IMPORT_THRESHOLD = 5;

var ContactViewTab;
(function (ContactViewTab) {
  ContactViewTab["COMPANY"] = "Company";
  ContactViewTab["LEAD"] = "Lead";
  ContactViewTab["OPPORTUNITY"] = "Opportunity";
  ContactViewTab["RELATED_COMPANIES"] = "Related Companies";
})(ContactViewTab || (ContactViewTab = {}));
var ContactViewSubTab;
(function (ContactViewSubTab) {
  ContactViewSubTab["OVERVIEW"] = "Overview";
  ContactViewSubTab["ACTIVITIES"] = "Activities";
  ContactViewSubTab["TASKS"] = "Tasks";
  ContactViewSubTab["PLAYBOOK"] = "Playbook";
})(ContactViewSubTab || (ContactViewSubTab = {}));
var PlaybookTab;
(function (PlaybookTab) {
  PlaybookTab["SNIPPETS"] = "Snippets";
  PlaybookTab["PITCHES"] = "Pitches";
  PlaybookTab["EMAILS"] = "Emails";
  PlaybookTab["LINKEDIN"] = "LinkedIn";
  PlaybookTab["QQS"] = "QQs";
})(PlaybookTab || (PlaybookTab = {}));

// TODO: Move this out of here and directly into the parser
var MessagesEvents;
(function (MessagesEvents) {
  MessagesEvents["UrlNotFound"] = "MESSAGES_EVENTS_URL_NOT_FOUND";
  MessagesEvents["UrlFound"] = "MESSAGES_EVENTS_URL_FOUND";
  MessagesEvents["ForceOpenExtension"] = "FORCE_OPEN_EXTENSION";
  MessagesEvents["UserLoggedIn"] = "USER_LOGGED_IN";
  MessagesEvents["UserLoggedOut"] = "USER_LOGGED_OUT";
  MessagesEvents["ActiveBobjectUpdated"] = "ACTIVE_BOBJECT_UPDATED";
  MessagesEvents["TaskCompleted"] = "TASK_COMPLETED";
  MessagesEvents["PlaybookFeed"] = "PLAYBOOK_FEED";
})(MessagesEvents || (MessagesEvents = {}));

var GLOBAL_PICKLISTS;
(function (GLOBAL_PICKLISTS) {
  GLOBAL_PICKLISTS["CADENCE"] = "CADENCE";
  GLOBAL_PICKLISTS["DATA_SOURCE"] = "DATA_SOURCE";
  GLOBAL_PICKLISTS["DISCARDED_REASON"] = "DISCARDED_REASON";
  GLOBAL_PICKLISTS["EMAIL"] = "EMAIL";
  GLOBAL_PICKLISTS["USER"] = "USER";
  GLOBAL_PICKLISTS["USE_CASE"] = "USE_CASE";
  GLOBAL_PICKLISTS["TIME_ZONE_GMT"] = "TIME_ZONE_GMT";
  GLOBAL_PICKLISTS["TASK_TYPE"] = "TASK_TYPE";
  GLOBAL_PICKLISTS["TARGET_MARKET"] = "TARGET_MARKET";
  GLOBAL_PICKLISTS["PITCH"] = "PITCH";
  GLOBAL_PICKLISTS["NURTURING_REASON"] = "NURTURING_REASON";
  GLOBAL_PICKLISTS["LINKEDIN_MESSAGE"] = "LINKEDIN_MESSAGE";
  GLOBAL_PICKLISTS["IDEAL_CUSTOMER_PROFILE"] = "IDEAL_CUSTOMER_PROFILE";
  GLOBAL_PICKLISTS["EMPLOYEE_ROLE"] = "EMPLOYEE_ROLE";
  GLOBAL_PICKLISTS["ON_HOLD_REASONS"] = "ON_HOLD_REASONS";
})(GLOBAL_PICKLISTS || (GLOBAL_PICKLISTS = {}));

var FilterType;
(function (FilterType) {
  FilterType["RANGE_BETWEEN"] = "RANGE__SEARCH__BETWEEN";
  FilterType["EXACT"] = "EXACT__SEARCH";
  FilterType["RANGE_GT"] = "RANGE__SEARCH__GT";
  FilterType["RANGE_GTE"] = "RANGE__SEARCH__GTE";
  FilterType["RANGE_LT"] = "RANGE__SEARCH__LT";
  FilterType["RANGE_LTE"] = "RANGE__SEARCH__LTE";
  FilterType["NOT_EMPTY"] = "IS__NOT__EMPTY";
  FilterType["EMPTY"] = "IS__EMPTY";
})(FilterType || (FilterType = {}));
var SearchType;
(function (SearchType) {
  SearchType["AUTOCOMPLETE"] = "AUTOCOMPLETE__SEARCH";
  SearchType["EXACT"] = "EXACT__SEARCH";
  SearchType["NOT"] = "NOT__SEARCH";
  SearchType["RANGE_BETWEEN"] = "RANGE__SEARCH__BETWEEN";
  SearchType["RANGE_BETWEEN_DATES"] = "RANGE__SEARCH__BETWEEN__DATES";
  SearchType["RANGE_GT"] = "RANGE__SEARCH__GT";
  SearchType["RANGE_GTE"] = "RANGE__SEARCH__GTE";
  SearchType["RANGE_LT"] = "RANGE__SEARCH__LT";
  SearchType["RANGE_LTE"] = "RANGE__SEARCH__LTE";
  SearchType["CUSTOM"] = "custom";
  SearchType["TODAY"] = "today";
  SearchType["THIS_WEEK"] = "this_week";
  SearchType["THIS_MONTH"] = "this_month";
  SearchType["THIS_QUARTER"] = "this_quarter";
  SearchType["THIS_YEAR"] = "this_year";
  SearchType["ALL_TIME"] = "all_time";
  SearchType["YESTERDAY"] = "yesterday";
  SearchType["LAST_WEEK"] = "last_week";
  SearchType["LAST_MONTH"] = "last_month";
  SearchType["LAST_QUARTER"] = "last_quarter";
  SearchType["LAST_YEAR"] = "last_year";
})(SearchType || (SearchType = {}));
var RelativesDate;
(function (RelativesDate) {
  RelativesDate["ALL_TIME"] = "all_time";
  RelativesDate["LAST_MONTH"] = "last_month";
  RelativesDate["LAST_QUARTER"] = "last_quarter";
  RelativesDate["LAST_WEEK"] = "last_week";
  RelativesDate["LAST_YEAR"] = "last_year";
  RelativesDate["NEXT_30_DAYS"] = "next_30_days";
  RelativesDate["NEXT_7_DAYS"] = "next_7_days";
  RelativesDate["SINCE_TODAY"] = "since_today";
  RelativesDate["MORE_THAN_6_MONTHS"] = "more_than_6_month";
  RelativesDate["NEXT_6_MONTHS"] = "next_6_months";
  RelativesDate["THIS_MONTH"] = "this_month";
  RelativesDate["THIS_QUARTER"] = "this_quarter";
  RelativesDate["THIS_WEEK"] = "this_week";
  RelativesDate["THIS_YEAR"] = "this_year";
  RelativesDate["TODAY"] = "today";
  RelativesDate["YESTERDAY"] = "yesterday";
  RelativesDate["UNTIL_NOW"] = "until_now";
})(RelativesDate || (RelativesDate = {}));
var SearchMode;
(function (SearchMode) {
  SearchMode["AUTOCOMPLETE"] = "AUTOCOMPLETE__SEARCH";
  SearchMode["EXACT"] = "EXACT__SEARCH";
  SearchMode["NOT"] = "NOT__SEARCH";
  SearchMode["RANGE"] = "RANGE__SEARCH";
  SearchMode["SUBQUERY"] = "SUBQUERY__SEARCH";
})(SearchMode || (SearchMode = {}));
var MatchRows;
(function (MatchRows) {
  MatchRows["FULL"] = "__MATCH_FULL_ROWS__";
  MatchRows["EMPTY"] = "__MATCH_EMPTY_ROWS__";
})(MatchRows || (MatchRows = {}));
var SearchTypeByKey;
(function (SearchTypeByKey) {
  SearchTypeByKey[SearchTypeByKey["gt"] = SearchType.RANGE_GT] = "gt";
  SearchTypeByKey[SearchTypeByKey["gte"] = SearchType.RANGE_GTE] = "gte";
  SearchTypeByKey[SearchTypeByKey["lt"] = SearchType.RANGE_LT] = "lt";
  SearchTypeByKey[SearchTypeByKey["lte"] = SearchType.RANGE_LTE] = "lte";
})(SearchTypeByKey || (SearchTypeByKey = {}));
var Direction;
(function (Direction) {
  Direction["ASC"] = "ASC";
  Direction["DESC"] = "DESC";
})(Direction || (Direction = {}));

var UserHelperKeys;
(function (UserHelperKeys) {
  UserHelperKeys["SEND_TO_SALSES_MODAL_FEEDBACK_STEP"] = "SEND_TO_SALSES_MODAL_FEEDBACK_STEP";
  UserHelperKeys["CHECK_OUT_YOUR_TARGET_MARKETS"] = "CHECK_OUT_YOUR_TARGET_MARKETS";
  UserHelperKeys["CHECK_OUT_YOUR_BUYER_PERSONAS"] = "CHECK_OUT_YOUR_BUYER_PERSONAS";
  UserHelperKeys["CREATE_YOUR_FIRST_CADENCE_STEP"] = "CREATE_YOUR_FIRST_CADENCE_STEP";
  UserHelperKeys["START_TASK_FROM_CADENCE"] = "START_TASK_FROM_CADENCE";
  UserHelperKeys["SET_UP_REMINDERS"] = "SET_UP_REMINDERS";
  UserHelperKeys["SET_YOUR_EMAIL_SIGNATURE"] = "SET_YOUR_EMAIL_SIGNATURE";
  UserHelperKeys["SEND_FIRST_AUTO_EMAIL"] = "SEND_FIRST_AUTO_EMAIL";
  UserHelperKeys["SAVE_NUMBER_SETTINGS"] = "SAVE_NUMBER_SETTINGS";
  UserHelperKeys["CREATE_YOUR_FIRST_PITCH"] = "CREATE_YOUR_FIRST_PITCH";
  UserHelperKeys["MARK_AS_DONE_ATTEMPT"] = "MARK_AS_DONE_ATTEMPT";
  UserHelperKeys["TAKE_TOUR_ON_OUTBOX"] = "TAKE_TOUR_ON_OUTBOX";
  UserHelperKeys["CREATE_FIRST_TARGET_MARKET"] = "CREATE_FIRST_TARGET_MARKET";
  UserHelperKeys["ADD_FIRST_BUYER_PERSONA"] = "ADD_FIRST_BUYER_PERSONA";
  UserHelperKeys["DEFINE_FIRST_SCENARIO"] = "DEFINE_FIRST_SCENARIO";
  UserHelperKeys["SET_COMPANY_FIELDS_TOUR"] = "SET_COMPANY_FIELDS_TOUR";
  UserHelperKeys["SET_LEAD_FIELDS_TOUR"] = "SET_LEAD_FIELDS_TOUR";
  UserHelperKeys["CHOOSE_DIALER"] = "CHOOSE_DIALER";
  UserHelperKeys["TAKE_TOUR_ON_GENERAL_SETTINGS"] = "TAKE_TOUR_ON_GENERAL_SETTINGS";
  UserHelperKeys["CONNECT_CRM_TOUR"] = "CONNECT_CRM_TOUR";
  UserHelperKeys["DEFINE_QQ"] = "DEFINE_QQ";
  UserHelperKeys["SET_UP_DASHBOARDS_TOUR"] = "SET_UP_DASHBOARDS_TOUR";
  UserHelperKeys["INVITE_TEAM"] = "INVITE_TEAM";
  UserHelperKeys["CREATE_FIRST_COMPANY"] = "CREATE_FIRST_COMPANY";
  UserHelperKeys["CREATE_FIRST_LEAD"] = "CREATE_FIRST_LEAD";
  UserHelperKeys["LAUNCH_YOUR_FIRST_CADENCE"] = "LAUNCH_YOUR_FIRST_CADENCE";
  UserHelperKeys["TAKE_TOUR_PROSPECT_TAB"] = "TAKE_TOUR_PROSPECT_TAB";
  UserHelperKeys["CALL_AND_REPORT_RESULT"] = "CALL_AND_REPORT_RESULT";
  UserHelperKeys["CREATE_LEAD_FROM_LINKEDIN"] = "CREATE_LEAD_FROM_LINKEDIN";
  UserHelperKeys["LINK_FIRST_MESSAGE_LINKEDIN"] = "LINK_FIRST_MESSAGE_LINKEDIN";
  UserHelperKeys["TAKE_TOUR_ON_INBOX"] = "TAKE_TOUR_ON_INBOX";
  UserHelperKeys["DOWNLOAD_CHROME_EXTENSION"] = "DOWNLOAD_CHROME_EXTENSION";
  UserHelperKeys["CREATE_FIRST_EMAIL_TEMPLATE"] = "CREATE_FIRST_EMAIL_TEMPLATE";
  UserHelperKeys["CREATE_YOUR_FIRST_CADENCE"] = "CREATE_YOUR_FIRST_CADENCE";
  UserHelperKeys["CONNECT_EMAIL_ACCOUNT"] = "CONNECT_EMAIL_ACCOUNT";
  UserHelperKeys["ENABLE_KPI_METRICS"] = "ENABLE_KPI_METRICS";
  UserHelperKeys["CREATE_FIRST_LIST"] = "CREATE_FIRST_LIST";
  UserHelperKeys["SEND_YOUR_FIRST_EMAIL"] = "SEND_YOUR_FIRST_EMAIL";
  UserHelperKeys["COMPLETE_WELCOME_SCREEN"] = "COMPLETE_WELCOME_SCREEN";
  UserHelperKeys["SEEN_INACTIVE_DISCOVERY_TOOLTIP"] = "SEEN_INACTIVE_DISCOVERY_TOOLTIP";
  UserHelperKeys["NEW_MEETING_MODAL"] = "NEW_MEETING_MODAL";
  UserHelperKeys["NEW_INVITEES_SYNC"] = "NEW_INVITEES_SYNC";
  UserHelperKeys["PREVIEW_EMAIL_MODAL"] = "PREVIEW_EMAIL_MODAL";
  UserHelperKeys["DONT_SHOW_AGAIN_CREATED_USER_MODAL"] = "DONT_SHOW_AGAIN_CREATED_USER_MODAL";
  UserHelperKeys["DONT_SHOW_AGAIN_MEETING_FUNNEL_DATE_HINT"] = "DONT_SHOW_AGAIN_MEETING_FUNNEL_DATE_HINT";
  UserHelperKeys["SCHEDULE_NEXT_STEP_DATETIME_FILTER"] = "SCHEDULE_NEXT_STEP_DATETIME_FILTER";
  UserHelperKeys["SHOW_DISABLED_VALUES_FILTERS_DASHBOARDS"] = "SHOW_DISABLED_VALUES_FILTERS_DASHBOARDS";
  UserHelperKeys["SHOW_DISABLED_VALUES_FILTERS_REPORTS"] = "SHOW_DISABLED_VALUES_FILTERS_REPORTS";
})(UserHelperKeys || (UserHelperKeys = {}));
var UserHelperTooltipsKeys;
(function (UserHelperTooltipsKeys) {
  UserHelperTooltipsKeys["WELCOME"] = "WELCOME";
  UserHelperTooltipsKeys["TAB_BAR"] = "TAB_BAR";
  UserHelperTooltipsKeys["TASKS"] = "TASKS";
  UserHelperTooltipsKeys["NOTIFICATIONS"] = "NOTIFICATIONS";
  UserHelperTooltipsKeys["MAIL_DISCOVERY_TOOLTIP"] = "MAIL_DISCOVERY_TOOLTIP";
  UserHelperTooltipsKeys["ON_CADENCE_DISCOVERY_TOOLTIP"] = "ON_CADENCE_DISCOVERY_TOOLTIP";
  UserHelperTooltipsKeys["COMPANIES_AND_LEADS_TOOLTIP"] = "COMPANIES_AND_LEADS_TOOLTIP";
  UserHelperTooltipsKeys["START_TO_FINISH"] = "START_TO_FINISH";
  UserHelperTooltipsKeys["ON_CADENCE_FILTERS"] = "ON_CADENCE_FILTERS";
  UserHelperTooltipsKeys["START_TASKS"] = "START_TASKS";
  UserHelperTooltipsKeys["OUTBOX_AUTOMATED_EMAILS"] = "OUTBOX_AUTOMATED_EMAILS";
  UserHelperTooltipsKeys["OUTBOX_AUTOMATED_BULK"] = "OUTBOX_AUTOMATED_BULK";
  UserHelperTooltipsKeys["OUTBOX_SCHEDULED_EMAILS"] = "OUTBOX_SCHEDULED_EMAILS";
  UserHelperTooltipsKeys["OUTBOX_SCHEDULED_ACTIONS"] = "OUTBOX_SCHEDULED_ACTIONS";
  UserHelperTooltipsKeys["OUTBOX_SCHEDULED_NO_EMAILS"] = "OUTBOX_SCHEDULED_NO_EMAILS";
  UserHelperTooltipsKeys["OUTBOX_SCHEDULED_PAGE"] = "OUTBOX_SCHEDULED_PAGE";
  UserHelperTooltipsKeys["INBOX_LEFT_SIDE_NAVIGATION"] = "INBOX_LEFT_SIDE_NAVIGATION";
  UserHelperTooltipsKeys["INBOX_FILTERS"] = "INBOX_FILTERS";
  UserHelperTooltipsKeys["INBOX_BULK_ACTIONS"] = "INBOX_BULK_ACTIONS";
  UserHelperTooltipsKeys["INBOX_INDIVIDUAL_ACTIONS"] = "INBOX_INDIVIDUAL_ACTIONS";
  UserHelperTooltipsKeys["INBOX_NO_TASKS"] = "INBOX_NO_TASKS";
  UserHelperTooltipsKeys["DASHBOARDS_GENERAL"] = "DASHBOARDS_GENERAL";
  UserHelperTooltipsKeys["DASHBOARDS_DATE_FILTER"] = "DASHBOARDS_DATE_FILTER";
  UserHelperTooltipsKeys["DASHBOARDS_GROUP_BY"] = "DASHBOARDS_GROUP_BY";
  UserHelperTooltipsKeys["DASHBOARDS_FILTERS"] = "DASHBOARDS_FILTERS";
  UserHelperTooltipsKeys["DASHBOARDS_ACTIVITY"] = "DASHBOARDS_ACTIVITY";
  UserHelperTooltipsKeys["GENERAL_SETTINGS_ASSIGNMENTS"] = "GENERAL_SETTINGS_ASSIGNMENTS";
  UserHelperTooltipsKeys["GENERAL_SETTINGS_MEETINGS"] = "GENERAL_SETTINGS_MEETINGS";
  UserHelperTooltipsKeys["GENERAL_SETTINGS_LEADS"] = "GENERAL_SETTINGS_LEADS";
  UserHelperTooltipsKeys["SHOW_QSG_FILTER"] = "SHOW_QSG_FILTER";
  UserHelperTooltipsKeys["SHOW_QSG_FILTER_INFO"] = "SHOW_QSG_FILTER_INFO";
  UserHelperTooltipsKeys["HUBSPOT_SYNCING"] = "HUBSPOT_SYNCING";
  UserHelperTooltipsKeys["HUBSPOT_LOGS"] = "HUBSPOT_LOGS";
  UserHelperTooltipsKeys["NO_HUBSPOT_LOGS"] = "NO_HUBSPOT_LOGS";
  UserHelperTooltipsKeys["HUBSPOT_OBJECTS_SYNCING"] = "HUBSPOT_OBJECTS_SYNCING";
  UserHelperTooltipsKeys["HUBSPOT_USERS"] = "HUBSPOT_USERS";
  UserHelperTooltipsKeys["HUBSPOT_FIELDS"] = "HUBSPOT_FIELDS";
  UserHelperTooltipsKeys["SALESFORCE_SYNCING"] = "SALESFORCE_SYNCING";
  UserHelperTooltipsKeys["SALESFORCE_LOGS"] = "SALESFORCE_LOGS";
  UserHelperTooltipsKeys["SALESFORCE_OBJECTS_SYNCING"] = "SALESFORCE_OBJECTS_SYNCING";
  UserHelperTooltipsKeys["SALESFORCE_USERS"] = "SALESFORCE_USERS";
  UserHelperTooltipsKeys["SALESFORCE_FIELDS"] = "SALESFORCE_FIELDS";
  UserHelperTooltipsKeys["NO_SALESFORCE_LOGS"] = "NO_SALESFORCE_LOGS";
  UserHelperTooltipsKeys["FIELDS_CHOOSE_BOBJECT"] = "FIELDS_CHOOSE_BOBJECT";
  UserHelperTooltipsKeys["FIELDS_CREATE"] = "FIELDS_CREATE";
  UserHelperTooltipsKeys["FIELDS_PREVIEW_FORMS"] = "FIELDS_PREVIEW_FORMS";
})(UserHelperTooltipsKeys || (UserHelperTooltipsKeys = {}));
var ExtensionHelperKeys;
(function (ExtensionHelperKeys) {
  ExtensionHelperKeys["PIPELINE_TAB_COMPANY_LAST_VISIT"] = "PIPELINE_TAB_COMPANY_LAST_VISIT";
  ExtensionHelperKeys["PIPELINE_TAB_LEAD_LAST_VISIT"] = "PIPELINE_TAB_LEAD_LAST_VISIT";
  ExtensionHelperKeys["PIPELINE_TAB_OPPORTUNITY_LAST_VISIT"] = "PIPELINE_TAB_OPPORTUNITY_LAST_VISIT";
  ExtensionHelperKeys["PIPELINE_TAB_FIRST_VISIT"] = "PIPELINE_TAB_FIRST_VISIT";
  ExtensionHelperKeys["SIDEPEEK_DISABLED"] = "SIDEPEEK_DISABLED";
})(ExtensionHelperKeys || (ExtensionHelperKeys = {}));
var CustomUserHelperKeys;
(function (CustomUserHelperKeys) {
  CustomUserHelperKeys["ALL_DEFAULT_TAB"] = "ALL_DEFAULT_TAB";
  CustomUserHelperKeys["COMPANIES_AND_LEADS_DEFAULT_TAB"] = "COMPANIESANDLEADS_DEFAULT_TAB";
  CustomUserHelperKeys["DELIVERED_DEFAULT_TAB"] = "DELIVERED_DEFAULT_TAB";
  CustomUserHelperKeys["INACTIVE_DEFAULT_TAB"] = "INACTIVE_DEFAULT_TAB";
  CustomUserHelperKeys["INACTIVE_SALES_DEFAULT_TAB"] = "INACTIVE_SALES_DEFAULT_TAB";
  CustomUserHelperKeys["HAVE_SAVED_FIELDS_CUSTOM_ORDER"] = "HAVE_SAVED_FIELDS_CUSTOM_ORDER";
})(CustomUserHelperKeys || (CustomUserHelperKeys = {}));

var HOME = '/';
var TERMS_AND_CONDITIONS = '/master-subscription-agreement';
var PRIVACY_POLICY = '/privacy-policy';
var LOGIN = '/login';
var EXTERNAL_ACTION = '/externalAction';
var EXTERNAL_ACTION_VALIDATE_EMAIL = "".concat(EXTERNAL_ACTION, "/validateEmail");
var EXTERNAL_ACTION_RESET_PASSWORD = "".concat(EXTERNAL_ACTION, "/resetPassword");
var EXTERNAL_ACTION_REQUEST_RESET_PASSWORD = "".concat(EXTERNAL_ACTION, "/requestResetPassword");
var EXTERNAL_ACTION_CONFIRM_INVITATION = "".concat(EXTERNAL_ACTION, "/userInvitation");
var EXTERNAL_ACTION_SIGN_AS = "".concat(EXTERNAL_ACTION, "/signAs");
var APP = '/app';
var APP_TASKS = "".concat(APP, "/tasks");
var APP_TASKS_INBOX = "".concat(APP_TASKS, "/inbox");
var APP_TASKS_INBOX_SECTION = "".concat(APP_TASKS, "/inbox/:slug?");
var APP_TASKS_ADD_QC = "".concat(APP_TASKS, "/addQc");
var APP_TASKS_INBOUND = "".concat(APP_TASKS, "/inbound");
var APP_TASKS_INBOUND_MQL = "".concat(APP_TASKS_INBOUND, "/mql");
var APP_TASKS_INBOUND_SAL = "".concat(APP_TASKS_INBOUND, "/sal");
var APP_TASKS_ASSIGN_QC = "".concat(APP_TASKS, "/assignQc");
var APP_TASKS_DONE = "".concat(APP_TASKS, "/done");
var APP_TASKS_WELCOME = "".concat(APP_TASKS, "/welcome");
var APP_TASKS_TASK = "".concat(APP_TASKS, "/:id");
var APP_TASKS_PROSPECTING = "".concat(APP_TASKS, "/prospecting");
var APP_TASKS_PROSPECTING_SECTION = "".concat(APP_TASKS, "/prospecting/:slug?/:section?");
var APP_TASKS_SALES = "".concat(APP_TASKS, "/sales");
var APP_TASKS_SALES_SECTION = "".concat(APP_TASKS, "/sales/:slug?/:section?");
var APP_TASKS_OUTBOX = "".concat(APP_TASKS, "/outbox");
var APP_TASKS_OUTBOX_SECTION = "".concat(APP_TASKS, "/outbox/:slug?");
var APP_CL = "".concat(APP, "/cl");
var APP_CL_LEADS = "".concat(APP_CL, "/leads");
var APP_CL_COMPANIES = "".concat(APP_CL, "/companies");
var APP_CL_OPPORTUNITIES = "".concat(APP_CL, "/opportunities");
var APP_CL_IMPORT = "".concat(APP_CL, "/import");
var APP_CL_IMPORT_HISTORY = "".concat(APP_CL, "/import/history");
var APP_CL_ACTIVITIES = "".concat(APP_CL, "/activities");
var APP_CL_TASKS = "".concat(APP_CL, "/tasks");
var APP_CL_LISTS = "".concat(APP_CL, "/lists");
var APP_CL_MEETINGS = "".concat(APP_CL, "/meetings");
var APP_CL_COMPANIES_NEW_VIEW = "".concat(APP_CL_COMPANIES, "?newView=true");
var APP_CL_LEADS_NEW_VIEW = "".concat(APP_CL_LEADS, "?newView=true");
var APP_CL_ACTIVITIES_NEW_VIEW = "".concat(APP_CL_ACTIVITIES, "?newView=true");
var APP_CL_OPPORTUNITIES_NEW_VIEW = "".concat(APP_CL_OPPORTUNITIES, "?newView=true");
var APP_CL_TASKS_NEW_VIEW = "".concat(APP_CL_TASKS, "?newView=true");
var APP_CL_COMPANIES_COMPANY = "".concat(APP_CL_COMPANIES, "/:id");
var APP_CL_COMPANIES_COMPANY_TASK = "".concat(APP_CL_COMPANIES, "/:companyId/tasks/:taskId");
var APP_CL_COMPANIES_COMPANY_OPPORTUNITY = "".concat(APP_CL_COMPANIES, "/:id/opportunities/:opportunityId");
var APP_CL_LEADS_LEAD = "".concat(APP_CL_LEADS, "/:id");
var APP_CL_OPPORTUNITIES_OPPORTUNITY = "".concat(APP_CL_OPPORTUNITIES, "/:id");

//Cadences
var APP_CADENCES = "".concat(APP, "/cadences");
var APP_CADENCES_MANAGE = "".concat(APP_CADENCES, "/manage");
var APP_CADENCES_ANALYZE = "".concat(APP_CADENCES, "/analyze");
var APP_CADENCES_EDIT = "".concat(APP_CADENCES, "/edit");
var APP_SINGLE_CADENCE = "".concat(APP_CADENCES, "/:cadenceId");
var APP_CADENCES_ANALYZE_CADENCE = "".concat(APP_CADENCES_ANALYZE, "/:slug");

//Dashboards
var APP_DASHBOARD = "".concat(APP, "/dashboards");
var APP_DASHBOARD_PROSPECTING = "".concat(APP_DASHBOARD, "/prospecting");
var APP_DASHBOARD_SALES = "".concat(APP_DASHBOARD, "/sales");
var APP_DASHBOARD_PROSPECTING_SECTION = "".concat(APP_DASHBOARD_PROSPECTING, "/:slug");
var APP_DASHBOARD_SALES_SECTION = "".concat(APP_DASHBOARD_SALES, "/:slug");

// User settings
var APP_MANAGEMENT = "".concat(APP, "/management");
var APP_MANAGEMENT_USER = "".concat(APP_MANAGEMENT, "/user");

// Account Settings - Base url
var APP_ACCOUNT = "".concat(APP, "/account-settings");

// Account Settings > General Settings
var APP_ACCOUNT_GENERAL_SETTINGS = "".concat(APP_ACCOUNT, "/general-settings");

// Account Settings > Sales Team
var APP_ACCOUNT_SALES_TEAM = "".concat(APP_ACCOUNT, "/sales-team");

// Account Settings > Chrome Extension
var APP_ACCOUNT_CHROME_EXTENSION = "".concat(APP_ACCOUNT, "/chrome-extension");

// Account Settings > Dialers
var APP_ACCOUNT_DIALERS = "".concat(APP_ACCOUNT, "/dialers");
var APP_ACCOUNT_DIALERS_TWILIO = "".concat(APP_ACCOUNT_DIALERS, "/twilio");
var APP_ACCOUNT_DIALERS_AIRCALL = "".concat(APP_ACCOUNT_DIALERS, "/aircall");
var APP_ACCOUNT_DIALERS_JUSTCALL = "".concat(APP_ACCOUNT_DIALERS, "/justcall");
// Extra route to handle redirect when auth in Aircall has finished
var APP_ACCOUNT_DIALERS_AIRCALL_REDIRECT = "".concat(APP_ACCOUNT, "/aircall");

// Account Settings > Email
var APP_ACCOUNT_EMAILS = "".concat(APP_ACCOUNT, "/emails");

// Account Settings > Notifications
var APP_ACCOUNT_NOTIFICATIONS = "".concat(APP_ACCOUNT, "/notifications");

// Account Settings > Views
var APP_ACCOUNT_VIEWS = "".concat(APP_ACCOUNT, "/views");

// Account Settings > Fields
var APP_ACCOUNT_FIELDS = "".concat(APP_ACCOUNT, "/fields");
var APP_ACCOUNT_GLOBAL_PICKLISTS = "".concat(APP_ACCOUNT, "/global-picklists");
var APP_ACCOUNT_GROUPS = "".concat(APP_ACCOUNT, "/groups");

// Account Settings > Automation pages - Base url
var APP_AUTOMATIONS = "".concat(APP_ACCOUNT, "/automations");

// Account Settings > Fields Dependencies
var APP_ACCOUNT_FIELD_DEPENDENCIES = "".concat(APP_ACCOUNT, "/field-dependencies");

// Account Settings - Integrations Base url
var APP_ACCOUNT_INTEGRATION = "".concat(APP_ACCOUNT, "/integration");

// Account Settings > Salesforce
var APP_ACCOUNT_INTEGRATION_SALESFORCE = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_TAB = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/:tab");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_CONNECT = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/connect");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_SYNC_SETTINGS = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/settings");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_SYNC_STATUS = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/sync");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_USERS = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/users");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_MAPPING = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/mapping");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_MAPPING_NAME = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/:tab/:mappingName");
var APP_ACCOUNT_INTEGRATION_SALESFORCE_OAUTH = "".concat(APP_ACCOUNT_INTEGRATION, "/salesforce/oauth");

// Account Settings > Hubspot
var APP_ACCOUNT_INTEGRATION_HUBSPOT_TAB = "".concat(APP_ACCOUNT_INTEGRATION, "/hubspot/:tab");
var APP_ACCOUNT_INTEGRATION_HUBSPOT_CONNECT = "".concat(APP_ACCOUNT_INTEGRATION, "/hubspot/connect");
var APP_ACCOUNT_INTEGRATION_HUBSPOT_SYNC_SETTINGS = "".concat(APP_ACCOUNT_INTEGRATION, "/hubspot/settings");
var APP_ACCOUNT_INTEGRATION_HUBSPOT_SYNC_STATUS = "".concat(APP_ACCOUNT_INTEGRATION, "/hubspot/sync");
var APP_ACCOUNT_INTEGRATION_HUBSPOT_USERS = "".concat(APP_ACCOUNT_INTEGRATION, "/hubspot/users");
var APP_ACCOUNT_INTEGRATION_HUBSPOT_MAPPING = "".concat(APP_ACCOUNT_INTEGRATION, "/hubspot/mapping");
var APP_ACCOUNT_INTEGRATION_HUBSPOT_OAUTH = "".concat(APP_ACCOUNT_INTEGRATION, "/hubspot/oauth");

// Account Settings > Dynamics
var APP_ACCOUNT_INTEGRATION_DYNAMICS_TAB = "".concat(APP_ACCOUNT_INTEGRATION, "/msndynamics/:tab");
var APP_ACCOUNT_INTEGRATION_DYNAMICS_CONNECT = "".concat(APP_ACCOUNT_INTEGRATION, "/msndynamics/connect");
var APP_ACCOUNT_INTEGRATION_DYNAMICS_SYNC_STATUS = "".concat(APP_ACCOUNT_INTEGRATION, "/msndynamics/sync");
var APP_ACCOUNT_INTEGRATION_DYNAMICS_SYNC_PICKLIST_MAPPINGS = "".concat(APP_ACCOUNT_INTEGRATION, "/msndynamics/picklists");
var APP_ACCOUNT_INTEGRATION_DYNAMICS_ACTIONS = "".concat(APP_ACCOUNT_INTEGRATION, "/msndynamics/actions");
var APP_ACCOUNT_INTEGRATION_DYNAMICS_MAPPING = "".concat(APP_ACCOUNT_INTEGRATION, "/msndynamics/mapping");
var APP_ACCOUNT_INTEGRATION_DYNAMICS_USERS = "".concat(APP_ACCOUNT_INTEGRATION, "/msndynamics/users");
var APP_ACCOUNT_INTEGRATION_DYNAMICS_SETTINGS = "".concat(APP_ACCOUNT_INTEGRATION, "/dynamics/settings");

// Account Settings > Vtiger
var APP_ACCOUNT_INTEGRATION_VTIGER_TAB = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/:tab");
var APP_ACCOUNT_INTEGRATION_VTIGER_CONNECT = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/connect");
var APP_ACCOUNT_INTEGRATION_VTIGER_SYNC_STATUS = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/sync");
var APP_ACCOUNT_INTEGRATION_VTIGER_SYNC_PICKLIST_MAPPINGS = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/picklists");
var APP_ACCOUNT_INTEGRATION_VTIGER_ACTIONS = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/actions");
var APP_ACCOUNT_INTEGRATION_VTIGER_MAPPING = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/mapping");
var APP_ACCOUNT_INTEGRATION_VTIGER_USERS = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/users");
var APP_ACCOUNT_INTEGRATION_VTIGER_SETTINGS = "".concat(APP_ACCOUNT_INTEGRATION, "/vtiger/settings");

// Account Settings > Api key
var APP_ACCOUNT_INTEGRATION_API_KEY = "".concat(APP_ACCOUNT_INTEGRATION, "/apiKey");

// Account Settings > IApp Connectors
var IAPP_INTEGRATIONS = ['pipedrive'
// "monday", // Add more iApp Integration keys here to expose them to router
];

var integrationURLs = function integrationURLs() {
  var integrationKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':integrationKey';
  return {
    APP_ACCOUNT_INTEGRATIONAPP_CONNECTOR_TAB: "".concat(APP_ACCOUNT_INTEGRATION, "/iapp/").concat(integrationKey, "/:tab"),
    APP_ACCOUNT_INTEGRATIONINTEGRATIONAPP_CONNECT: "".concat(APP_ACCOUNT_INTEGRATION, "/iapp/").concat(integrationKey, "/connect"),
    APP_ACCOUNT_INTEGRATIONAPP_CONNECTOR_SYNC_SETTINGS: "".concat(APP_ACCOUNT_INTEGRATION, "/iapp/").concat(integrationKey, "/settings"),
    APP_ACCOUNT_INTEGRATIONAPP_CONNECTOR_USERS: "".concat(APP_ACCOUNT_INTEGRATION, "/iapp/").concat(integrationKey, "/users")
  };
};

// Playbook - Base url
var APP_PLAYBOOK = "".concat(APP, "/playbook");

// Playbook > Target Markets
var APP_PLAYBOOK_TARGET_MARKET = "".concat(APP_PLAYBOOK, "/target-markets");

// Playbook > Buyer Personas
var APP_PLAYBOOK_BUYER_PERSONAS = "".concat(APP_PLAYBOOK, "/buyer-personas");

// Playbook > Scenarios
var APP_PLAYBOOK_SCENARIOS = "".concat(APP_PLAYBOOK, "/scenarios");

// Playbook > Cadences
var APP_PLAYBOOK_CADENCES = "".concat(APP_PLAYBOOK, "/cadences");
var APP_PLAYBOOK_CADENCES_EDIT = "".concat(APP_PLAYBOOK_CADENCES, "/edit");
var APP_PLAYBOOK_SINGLE_CADENCE = "".concat(APP_PLAYBOOK_CADENCES, "/:cadenceId");

// Playbook - Products
var APP_PLAYBOOK_PRODUCTS = "".concat(APP_PLAYBOOK, "/products");
var APP_PLAYBOOK_PRODUCTS_CATEGORIES = "".concat(APP_PLAYBOOK, "/products/categories");

// Playbook > Messaging segmentation
var APP_PLAYBOOK_MESSAGING_SEGMENTATION = "".concat(APP_PLAYBOOK, "/messaging-segmentation");

// Playbook > Sales pipeline
var APP_PLAYBOOK_SALES_PIPELINE = "".concat(APP_PLAYBOOK, "/sales-pipeline");

// Playbook - Messaging base url
var APP_PLAYBOOK_MESSAGING = "".concat(APP_PLAYBOOK, "/messaging");

// Playbook > Pitches and snippets
var APP_PLAYBOOK_MESSAGING_PITCH = "".concat(APP_PLAYBOOK_MESSAGING, "/pitch");
var APP_PLAYBOOK_MESSAGING_PITCH_FORM = "".concat(APP_PLAYBOOK_MESSAGING_PITCH, "/form");
// Playbook > Email templates
var APP_PLAYBOOK_MESSAGING_EMAIL = "".concat(APP_PLAYBOOK_MESSAGING, "/email");
var APP_PLAYBOOK_MESSAGING_EMAIL_FORM = "".concat(APP_PLAYBOOK_MESSAGING_EMAIL, "/form");

// Playbook > Linkedin templates
var APP_PLAYBOOK_MESSAGING_LINKEDIN = "".concat(APP_PLAYBOOK_MESSAGING, "/linkedin");
var APP_PLAYBOOK_MESSAGING_LINKEDIN_FORM = "".concat(APP_PLAYBOOK_MESSAGING_LINKEDIN, "/form");

// Playbook > Qualifiying question
var APP_PLAYBOOK_MESSAGING_QQ = "".concat(APP_PLAYBOOK_MESSAGING, "/qq");
var APP_PLAYBOOK_MESSAGING_QQ_FORM = "".concat(APP_PLAYBOOK_MESSAGING_QQ, "/form");
var APP_PLAYBOOK_MESSAGING_QQ_SCORES = "".concat(APP_PLAYBOOK_MESSAGING_QQ, "/scores");
var APP_PLAYBOOK_MESSAGING_QQ_ONE = "".concat(APP_PLAYBOOK_MESSAGING_QQ, "/:id");

// Playbook > Workflows
var APP_PLAYBOOK_MESSAGING_WORKFLOWS = "".concat(APP_PLAYBOOK_MESSAGING, "/workflows");
var APP_PLAYBOOK_MESSAGING_WORKFLOWS_EDIT = "".concat(APP_PLAYBOOK_MESSAGING_WORKFLOWS, "/edit");

// START - OLD URL'S
var APP_MANAGEMENT_ACCOUNT = "".concat(APP_MANAGEMENT, "/account");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION = "".concat(APP_MANAGEMENT_ACCOUNT, "/configuration");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_TAB = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce/:tab");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_CONNECT = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce/connect");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_SYNC_SETTINGS = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce/settings");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_SYNC_STATUS = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce/sync");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_USERS = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce/users");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_MAPPING = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce/mapping");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_OAUTH = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/salesforce/oauth");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_TAB = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/hubspot/:tab");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_CONNECT = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/hubspot/connect");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_SYNC_SETTINGS = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/hubspot/settings");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_SYNC_STATUS = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/hubspot/sync");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_USERS = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/hubspot/users");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_MAPPING = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/hubspot/mapping");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_OAUTH = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/hubspot/oauth");
var APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_DYNAMICS_TAB = "".concat(APP_MANAGEMENT_ACCOUNT_CONFIGURATION, "/integrations/dynamics");
var APP_MANAGEMENT_ACCOUNT_DIALERS = "".concat(APP_MANAGEMENT_ACCOUNT, "/dialer");
var APP_MANAGEMENT_ACCOUNT_DIALERS_TWILIO = "".concat(APP_MANAGEMENT_ACCOUNT, "/dialer/twilio");
var APP_MANAGEMENT_ACCOUNT_DIALERS_AIRCALL = "".concat(APP_MANAGEMENT_ACCOUNT, "/dialer/aircall");
// Extra route to handle redirect when auth in Aircall has finished
var APP_MANAGEMENT_ACCOUNT_DIALERS_AIRCALL_REDIRECT = "".concat(APP_MANAGEMENT_ACCOUNT, "/aircall");
var APP_MANAGEMENT_ACCOUNT_PREFERENCES = "".concat(APP_MANAGEMENT_ACCOUNT, "/preferences");
var APP_MANAGEMENT_ACCOUNT_PREFERENCES_USERS = "".concat(APP_MANAGEMENT_ACCOUNT_PREFERENCES, "/users");
var APP_MANAGEMENT_ACCOUNT_PREFERENCES_GENERAL_SETTINGS = "".concat(APP_MANAGEMENT_ACCOUNT_PREFERENCES, "/generalSettings");
var APP_MANAGEMENT_ACCOUNT_PREFERENCES_NOTIFICATIONS = "".concat(APP_MANAGEMENT_ACCOUNT_PREFERENCES, "/notifications");
var APP_MANAGEMENT_ACCOUNT_PREFERENCES_VIEWS = "".concat(APP_MANAGEMENT_ACCOUNT_PREFERENCES, "/views");
var APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT = "".concat(APP_MANAGEMENT_ACCOUNT, "/dataManagement");
var APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_FIELDS = "".concat(APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT, "/fields");
var APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_GLOBAL_PICKLISTS = "".concat(APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT, "/globalPicklists");
var APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_GROUPS = "".concat(APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT, "/groups");
var APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_DEPENDENCIES = "".concat(APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT, "/dependencies");
var APP_MANAGEMENT_ACCOUNT_MESSAGING = "".concat(APP_MANAGEMENT_ACCOUNT, "/messaging");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_PITCH = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING, "/pitch");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_EMAIL = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING, "/email");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_LINKEDIN = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING, "/linkedin");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING, "/qq");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_SEGMENTATION = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING, "/messaging-segmentation");
var APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING, "/business-assets");
var APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_TARGET_MARKET = "".concat(APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS, "/targetMarkets");
var APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_BUYER_PERSONAS = "".concat(APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS, "/buyerPersonas");
var APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_SCENARIOS = "".concat(APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS, "/scenarios");
var APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_CADENCES = "".concat(APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS, "/cadences");
var APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_CADENCES_EDIT = "".concat(APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_CADENCES, "/edit");
var APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_SINGLE_CADENCE = "".concat(APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_CADENCES, "/:cadenceId");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_EMAIL_FORM = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING_EMAIL, "/form");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_LINKEDIN_FORM = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING_LINKEDIN, "/form");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_PITCH_FORM = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING_PITCH, "/form");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ_FORM = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ, "/form");
var APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ_SCORES = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ, "/scores");

// TODO: Find usage and replace by new ones above
var APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ_ONE = "".concat(APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ, "/:id");
// END - OLD URL'S

var cadenceEditUrl = function cadenceEditUrl(cadenceId) {
  return "".concat(APP_PLAYBOOK_CADENCES_EDIT, "?cadence=").concat(cadenceId);
};
var cadenceEditUrlV2 = function cadenceEditUrlV2(cadenceId) {
  return "".concat(APP_CADENCES_EDIT, "?cadence=").concat(cadenceId);
};
var workflowEditUrl = function workflowEditUrl(workflowId) {
  return "".concat(APP_PLAYBOOK_MESSAGING_WORKFLOWS_EDIT, "?workflow=").concat(workflowId);
};
var taskUrl = function taskUrl(task) {
  return "".concat(APP_TASKS, "/").concat(task.id.objectId);
};
var activityUrl = function activityUrl(activity) {
  return "".concat(APP_CL_ACTIVITIES, "/").concat(activity.id.objectId);
};
var companyUrl = function companyUrl(company) {
  if (company) {
    return "".concat(APP_CL_COMPANIES, "/").concat(company.id.objectId);
  }
  return APP_CL_COMPANIES;
};
var companyIdUrl = function companyIdUrl(companyId) {
  var _companyId;
  if (((_companyId = companyId) === null || _companyId === void 0 ? void 0 : _companyId.indexOf('/')) > 0) {
    companyId = companyId.split('/')[2];
  }
  return "".concat(APP_CL_COMPANIES, "/").concat(companyId);
};
var opportunityUrl = function opportunityUrl(companyId, opportunityId) {
  return !companyId ? "".concat(APP_CL_OPPORTUNITIES, "/").concat(opportunityId) : "".concat(APP_CL_COMPANIES, "/").concat(companyId, "/opportunities/").concat(opportunityId);
};
var companyTaskUrl = function companyTaskUrl(companyId, taskId) {
  var _companyId2;
  if (((_companyId2 = companyId) === null || _companyId2 === void 0 ? void 0 : _companyId2.indexOf('/')) > 0) {
    companyId = companyId.split('/')[2];
  }
  return "".concat(APP_CL_COMPANIES, "/").concat(companyId, "/tasks/").concat(taskId.id.objectId);
};
var leadTaskUrl = function leadTaskUrl(leadId, taskId) {
  var _leadId;
  if (((_leadId = leadId) === null || _leadId === void 0 ? void 0 : _leadId.indexOf('/')) > 0) {
    leadId = leadId.split('/')[2];
  }
  return "".concat(APP_CL_LEADS, "/").concat(leadId, "/tasks/").concat(taskId.id.objectId);
};
var leadUrl = function leadUrl(lead, company) {
  var _company$id, _lead3, _lead3$id;
  if (typeof lead === 'string') {
    var _lead;
    if (((_lead = lead) === null || _lead === void 0 ? void 0 : _lead.indexOf('/')) > 0) {
      lead = lead.split('/')[2];
    }
    return "".concat(APP_CL_LEADS, "/").concat(lead);
  }
  if (company !== null && company !== void 0 && (_company$id = company.id) !== null && _company$id !== void 0 && _company$id.objectId) {
    var _company$id2, _lead2, _lead2$id;
    return "".concat(APP_CL_COMPANIES, "/").concat(company === null || company === void 0 ? void 0 : (_company$id2 = company.id) === null || _company$id2 === void 0 ? void 0 : _company$id2.objectId, "?leadId=").concat((_lead2 = lead) === null || _lead2 === void 0 ? void 0 : (_lead2$id = _lead2.id) === null || _lead2$id === void 0 ? void 0 : _lead2$id.value);
  }
  return "".concat(APP_CL_LEADS, "/").concat((_lead3 = lead) === null || _lead3 === void 0 ? void 0 : (_lead3$id = _lead3.id) === null || _lead3$id === void 0 ? void 0 : _lead3$id.objectId);
};
var bobjectUrl = function bobjectUrl(bobject) {
  var _bobject$id;
  var referencedBobject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    id: undefined
  };
  if (!bobject) {
    return '';
  }
  var bobjectType = bobject === null || bobject === void 0 ? void 0 : (_bobject$id = bobject.id) === null || _bobject$id === void 0 ? void 0 : _bobject$id.typeName;
  if (bobjectType === BOBJECT_TYPES.COMPANY) {
    return companyUrl(bobject);
  }
  if (bobjectType === BOBJECT_TYPES.LEAD) {
    return leadUrl(bobject, referencedBobject);
  }
  if (bobjectType === BOBJECT_TYPES.TASK) {
    return taskUrl(bobject);
  }
  if (bobjectType === BOBJECT_TYPES.ACTIVITY) {
    return activityUrl(bobject);
  }
  if (bobjectType === BOBJECT_TYPES.OPPORTUNITY) {
    var _referencedBobject$id, _bobject$id2;
    return opportunityUrl(referencedBobject === null || referencedBobject === void 0 ? void 0 : (_referencedBobject$id = referencedBobject.id) === null || _referencedBobject$id === void 0 ? void 0 : _referencedBobject$id.objectId, bobject === null || bobject === void 0 ? void 0 : (_bobject$id2 = bobject.id) === null || _bobject$id2 === void 0 ? void 0 : _bobject$id2.objectId);
  }
  throw new Error("Cannot generate url of bobject type ".concat(bobjectType));
};

var getQuickStartGuideBlocks = function getQuickStartGuideBlocks(params) {
  var _params$LINKEDIN_SALE, _params$LINKEDIN_SALE2;
  var cadenceV2Enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return [{
    title: 'Prepare your pipeline',
    key: 'PREPARE_PIPELINE',
    icon: 'personAdd',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Add your first Company',
      key: UserHelperKeys.CREATE_FIRST_COMPANY,
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered?fromGuide=Company")
    }, {
      label: 'Add your first Lead',
      key: UserHelperKeys.CREATE_FIRST_LEAD,
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered/leads?fromGuide=Lead")
    }, {
      label: 'Check your Target Markets',
      key: UserHelperKeys.CHECK_OUT_YOUR_TARGET_MARKETS,
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered?fromGuide=TargetMarket"),
      linkYoutube: 'https://www.youtube.com/watch?v=_nbPstSdVhw'
    }, {
      label: 'Check your Buyer Personas',
      key: UserHelperKeys.CHECK_OUT_YOUR_BUYER_PERSONAS,
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered/leads?fromGuide=BuyerPersona"),
      linkYoutube: 'https://www.youtube.com/watch?v=_nbPstSdVhw'
    }]
  }, {
    title: 'Set up to start prospecting',
    key: 'START_PROSPECTING',
    icon: 'play',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Create your first cadence',
      key: UserHelperKeys.CREATE_YOUR_FIRST_CADENCE,
      linkYoutube: 'https://www.youtube.com/watch?v=PBJP5hg3HPs',
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4821987345308-Cadence',
      linkNavigation: "".concat(cadenceV2Enabled ? APP_CADENCES_MANAGE : APP_PLAYBOOK_CADENCES)
    }, {
      label: 'Add your first cadence step',
      key: UserHelperKeys.CREATE_YOUR_FIRST_CADENCE_STEP,
      linkYoutube: 'https://www.youtube.com/watch?v=PBJP5hg3HPs',
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4821987345308-Cadence',
      linkNavigation: "".concat(cadenceV2Enabled ? APP_CADENCES_MANAGE : APP_PLAYBOOK_CADENCES)
    }, {
      label: 'Take a tour on your prospect tab',
      key: UserHelperKeys.TAKE_TOUR_PROSPECT_TAB,
      linkTour: "".concat(APP_TASKS_PROSPECTING, "/delivered?tour=true"),
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered?tour=true")
    }, {
      label: 'Launch your first cadence',
      key: UserHelperKeys.LAUNCH_YOUR_FIRST_CADENCE,
      linkYoutube: 'https://www.youtube.com/watch?v=TsrIpdqPBpA',
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered?fromGuide=LaunchCadence")
    }, {
      label: 'Start tasks from your “On Cadence” page',
      key: UserHelperKeys.START_TASK_FROM_CADENCE,
      linkYoutube: 'https://www.youtube.com/watch?v=JjBAmFFwg2c',
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/onCadence?fromGuide=StartTasks")
    }, {
      label: 'Mark as done your first attempt',
      key: UserHelperKeys.MARK_AS_DONE_ATTEMPT,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/5699779759772-Mark-as-done',
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/onCadence?fromGuide=MarkAsDone")
    }, {
      label: 'Set up your reminders',
      key: UserHelperKeys.SET_UP_REMINDERS,
      linkNavigation: "".concat(APP_MANAGEMENT_USER, "?tab=REMINDERS")
    }]
  }, {
    title: 'Start sending emails',
    key: 'SEND_EMAILS',
    icon: 'mail',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Connect your email account',
      key: UserHelperKeys.CONNECT_EMAIL_ACCOUNT,
      linkNavigation: "".concat(APP_MANAGEMENT_USER, "?tab=EMAIL")
    }, {
      label: 'Create your first email template',
      key: UserHelperKeys.CREATE_FIRST_EMAIL_TEMPLATE,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4838268707868-Templates',
      linkNavigation: "".concat(APP_PLAYBOOK_MESSAGING_EMAIL)
    }, {
      label: 'Set up your signature',
      key: UserHelperKeys.SET_YOUR_EMAIL_SIGNATURE,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360017107580-Email-signature',
      linkNavigation: "".concat(APP_MANAGEMENT_USER, "?tab=EMAIL")
    }, {
      label: 'Send your first email',
      key: UserHelperKeys.SEND_YOUR_FIRST_EMAIL,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360012893040-Connect-and-test-your-Gmail-account'
    }, {
      label: 'Create an automatic cadence',
      key: UserHelperKeys.SEND_FIRST_AUTO_EMAIL,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/5007917208348-Email-Automation',
      linkNavigation: cadenceV2Enabled ? APP_CADENCES_MANAGE : APP_PLAYBOOK_CADENCES
    }]
  }, {
    title: 'Get ready to call',
    key: 'READY_TO_CALL',
    icon: 'phone',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Create your first pitch',
      key: UserHelperKeys.CREATE_YOUR_FIRST_PITCH,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/5592273342364-Create-your-first-pitch-for-calls',
      linkNavigation: "".concat(APP_PLAYBOOK_MESSAGING_PITCH)
    }, {
      label: 'Save your phone number settings',
      key: UserHelperKeys.SAVE_NUMBER_SETTINGS,
      linkNavigation: "".concat(APP_MANAGEMENT_USER, "?tab=CALLS")
    }, {
      label: 'Call and report the result',
      key: UserHelperKeys.CALL_AND_REPORT_RESULT,
      linkYoutube: 'https://www.youtube.com/watch?v=r5-vQtD2WE0'
    }]
  }, {
    title: 'Sync your LinkedIn and Sales Navigator activity',
    key: 'LINKEDIN_SALES',
    icon: 'linkedin',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Download the Chrome Extension',
      key: UserHelperKeys.DOWNLOAD_CHROME_EXTENSION,
      linkNavigation: "https://chrome.google.com/webstore/detail/bloobirds/bfnmjliageccndnbpoadbigbnhicogbh"
    }, {
      label: 'Capture your first lead from LinkedIn',
      key: UserHelperKeys.CREATE_LEAD_FROM_LINKEDIN,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4894165417500-Chrome-extension',
      linkYoutube: 'https://www.youtube.com/watch?v=vOd9YOCVj6I',
      linkNavigation: params !== null && params !== void 0 && (_params$LINKEDIN_SALE = params.LINKEDIN_SALES) !== null && _params$LINKEDIN_SALE !== void 0 && _params$LINKEDIN_SALE.hasExtension ? 'https://www.linkedin.com/in/tonipereznavarro/' : 'https://chrome.google.com/webstore/detail/bloobirds/bfnmjliageccndnbpoadbigbnhicogbh'
    }, {
      label: 'Sync and check your first conversation in the inbox',
      key: UserHelperKeys.LINK_FIRST_MESSAGE_LINKEDIN,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360011435079-How-are-LinkedIn-messages-synchronised',
      linkYoutube: 'https://www.youtube.com/watch?v=buPWAn3w3v8',
      linkNavigation: params !== null && params !== void 0 && (_params$LINKEDIN_SALE2 = params.LINKEDIN_SALES) !== null && _params$LINKEDIN_SALE2 !== void 0 && _params$LINKEDIN_SALE2.hasExtension ? "".concat(APP_TASKS_INBOX, "/linkedin") : 'https://chrome.google.com/webstore/detail/bloobirds/bfnmjliageccndnbpoadbigbnhicogbh'
    }]
  }, {
    title: 'Track your message and progress',
    key: 'MESSAGE_PROGRESS',
    icon: 'activity',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Take the Bloobirds Inbox tour',
      key: UserHelperKeys.TAKE_TOUR_ON_INBOX,
      linkTour: "".concat(APP_TASKS_INBOX, "?tour=true"),
      linkNavigation: "".concat(APP_TASKS_INBOX, "?tour=true")
    }, {
      label: 'Take the Bloobirds Outbox tour',
      key: UserHelperKeys.TAKE_TOUR_ON_OUTBOX,
      linkTour: "".concat(APP_TASKS_OUTBOX, "?tour=true"),
      linkNavigation: "".concat(APP_TASKS_OUTBOX, "?tour=true")
    }, {
      label: 'Create your first list',
      key: UserHelperKeys.CREATE_FIRST_LIST,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360011351999-Create-custom-lists',
      linkNavigation: "".concat(APP_CL_LISTS, "?fromGuide=createList")
    }, {
      label: 'Enable your metric KPI metrics and activity',
      key: UserHelperKeys.ENABLE_KPI_METRICS
    }]
  }];
};

var getAdminQuickStartGuideBlocks = function getAdminQuickStartGuideBlocks(params) {
  var _params$READY_TO_LINK, _params$READY_TO_LINK2;
  var cadenceV2Enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return [{
    title: 'Define your playbook data model',
    key: 'DEFINE_PLAYBOOK',
    icon: 'book',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Add your first Target Market',
      key: UserHelperKeys.CREATE_FIRST_TARGET_MARKET,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360011337920-Target-markets',
      linkYoutube: 'https://www.youtube.com/watch?v=hYfvqkKMG84',
      linkNavigation: "".concat(APP_PLAYBOOK_TARGET_MARKET)
    }, {
      label: 'Customize your company fields',
      key: UserHelperKeys.SET_COMPANY_FIELDS_TOUR,
      linkNavigation: "".concat(APP_ACCOUNT_FIELDS, "?tour=true"),
      linkTour: "".concat(APP_ACCOUNT_FIELDS, "?tour=true"),
      linkYoutube: 'https://www.youtube.com/watch?v=07MkgZ9abwo',
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4917275864348-Fields-System-and-custom-fields'
    }, {
      label: 'Add your first Company',
      key: UserHelperKeys.CREATE_FIRST_COMPANY,
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered?fromGuide=Company")
    }, {
      label: 'Add your first Buyer Persona (ICP)',
      key: UserHelperKeys.ADD_FIRST_BUYER_PERSONA,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4821072507420-Buyer-Persona-ICP-',
      linkYoutube: 'https://www.youtube.com/watch?v=ZvHUhtLvQSo',
      linkNavigation: "".concat(APP_PLAYBOOK_BUYER_PERSONAS)
    }, {
      label: 'Customize your lead fields',
      key: UserHelperKeys.SET_LEAD_FIELDS_TOUR,
      linkNavigation: "".concat(APP_ACCOUNT_FIELDS, "?tour=true"),
      linkTour: "".concat(APP_ACCOUNT_FIELDS, "?tour=true"),
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4917275864348-Fields-System-and-custom-fields',
      linkYoutube: 'https://www.youtube.com/watch?v=07MkgZ9abwo'
    }, {
      label: 'Add your first Lead',
      key: UserHelperKeys.CREATE_FIRST_LEAD,
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered/leads?fromGuide=Lead")
    }, {
      label: 'Define your Scenario',
      key: UserHelperKeys.DEFINE_FIRST_SCENARIO,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4821141316892-Scenarios',
      linkNavigation: "".concat(APP_PLAYBOOK_SCENARIOS)
    }, {
      label: 'Take the General Settings Tour',
      key: UserHelperKeys.TAKE_TOUR_ON_GENERAL_SETTINGS,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4862184280476-General-settings',
      linkNavigation: "".concat(APP_ACCOUNT_GENERAL_SETTINGS, "?tour=true"),
      linkTour: "".concat(APP_ACCOUNT_GENERAL_SETTINGS, "?tour=true")
    }]
  }, {
    title: 'Prepare your playbook messaging',
    key: 'PREPARE_PLAYBOOK_MESSAGING',
    icon: 'book',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Create your templates',
      key: UserHelperKeys.CREATE_FIRST_EMAIL_TEMPLATE,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4838268707868-Templates',
      linkNavigation: APP_PLAYBOOK_MESSAGING_EMAIL
    }, {
      label: 'Define your Qualifying Questions',
      key: UserHelperKeys.DEFINE_QQ,
      linkYoutube: 'https://www.youtube.com/watch?v=aoR5_mLrHXM',
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4838746882460-Qualifying-Questions',
      linkNavigation: APP_PLAYBOOK_MESSAGING_QQ
    }, {
      label: 'Create your first cadence',
      key: UserHelperKeys.CREATE_YOUR_FIRST_CADENCE,
      linkYoutube: 'https://www.youtube.com/watch?v=PBJP5hg3HPs',
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4821987345308-Cadence',
      linkNavigation: cadenceV2Enabled ? APP_CADENCES_MANAGE : APP_PLAYBOOK_CADENCES
    }, {
      label: 'Launch your first cadence',
      key: UserHelperKeys.LAUNCH_YOUR_FIRST_CADENCE,
      linkYoutube: 'https://www.youtube.com/watch?v=TsrIpdqPBpA',
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered?fromGuide=LaunchCadence")
    }, {
      label: 'Take a tour on your prospect Tab',
      key: UserHelperKeys.TAKE_TOUR_PROSPECT_TAB,
      linkTour: "".concat(APP_TASKS_PROSPECTING, "/delivered?tour=true"),
      linkNavigation: "".concat(APP_TASKS_PROSPECTING, "/delivered?tour=true")
    }]
  }, {
    title: 'Get ready to call',
    key: 'READY_TO_CALL',
    icon: 'phone',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Set up your dialer',
      key: UserHelperKeys.CHOOSE_DIALER,
      linkYoutube: 'https://youtube.com/playlist?list=PLUEmsJXX4pOoENHH25f-jgrqdc1XgzbKN',
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4916094035996-Dialers',
      linkNavigation: APP_ACCOUNT_DIALERS
    }, {
      label: 'Make your first call',
      key: UserHelperKeys.CALL_AND_REPORT_RESULT,
      linkYoutube: 'https://www.youtube.com/watch?v=r5-vQtD2WE0'
    }]
  }, {
    title: 'Get ready to send emails',
    key: 'READY_TO_SEND_EMAIL',
    icon: 'mail',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Connect your email account',
      key: UserHelperKeys.CONNECT_EMAIL_ACCOUNT,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4860937296284-Email',
      linkNavigation: "".concat(APP_MANAGEMENT_USER, "?tab=EMAIL")
    }, {
      label: 'Send your first email',
      key: UserHelperKeys.SEND_YOUR_FIRST_EMAIL,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360012893040-Connect-and-test-your-Gmail-account'
    }]
  }, {
    title: 'Get ready to sync LinkedIn',
    key: 'READY_TO_LINKEDIN',
    icon: 'linkedin',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Install our Chrome Extension',
      key: UserHelperKeys.DOWNLOAD_CHROME_EXTENSION,
      linkNavigation: 'https://chrome.google.com/webstore/detail/bloobirds/bfnmjliageccndnbpoadbigbnhicogbh',
      linkYoutube: 'https://www.youtube.com/watch?v=iizyQXAI-mk'
    }, {
      label: 'Create your first lead from LinkedIn',
      key: UserHelperKeys.CREATE_LEAD_FROM_LINKEDIN,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4894165417500-Chrome-extension',
      linkYoutube: 'https://www.youtube.com/watch?v=vOd9YOCVj6I',
      linkNavigation: params !== null && params !== void 0 && (_params$READY_TO_LINK = params.READY_TO_LINKEDIN) !== null && _params$READY_TO_LINK !== void 0 && _params$READY_TO_LINK.hasExtension ? 'https://www.linkedin.com/in/tonipereznavarro/' : 'https://chrome.google.com/webstore/detail/bloobirds/bfnmjliageccndnbpoadbigbnhicogbh'
    }, {
      label: 'Sync and check your first conversation in the inbox',
      key: UserHelperKeys.LINK_FIRST_MESSAGE_LINKEDIN,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360011435079-How-are-LinkedIn-messages-synchronised',
      linkYoutube: 'https://www.youtube.com/watch?v=buPWAn3w3v8',
      linkNavigation: params !== null && params !== void 0 && (_params$READY_TO_LINK2 = params.READY_TO_LINKEDIN) !== null && _params$READY_TO_LINK2 !== void 0 && _params$READY_TO_LINK2.hasExtension ? "".concat(APP_TASKS_INBOX, "/linkedin") : 'https://chrome.google.com/webstore/detail/bloobirds/bfnmjliageccndnbpoadbigbnhicogbh'
    }, {
      label: 'Take the Bloobirds Inbox tour',
      key: UserHelperKeys.TAKE_TOUR_ON_INBOX,
      linkTour: "".concat(APP_TASKS_INBOX, "?tour=true"),
      linkNavigation: "".concat(APP_TASKS_INBOX, "?tour=true")
    }]
  }, {
    title: 'Integrate your CRM with Bloobirds',
    key: 'INTEGRATE_TOOLS',
    icon: 'settings',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Connect your CRM',
      key: UserHelperKeys.CONNECT_CRM_TOUR
    }]
  }, {
    title: 'Track and measure your progress',
    key: 'TRACK_AND_MEASURE_PROGRESS',
    icon: 'activity',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Set up your dashboards view',
      key: UserHelperKeys.SET_UP_DASHBOARDS_TOUR,
      linkNavigation: "".concat(APP_DASHBOARD_PROSPECTING, "/overview"),
      linkTour: "".concat(APP_DASHBOARD_PROSPECTING, "/overview")
    }, {
      label: 'Create your first custom list',
      key: UserHelperKeys.CREATE_FIRST_LIST,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/360011351999-Create-custom-lists',
      linkNavigation: "".concat(APP_CL_LISTS, "?fromGuide=createList")
    }, {
      label: 'Enable your metric KPI metrics and activity',
      key: UserHelperKeys.ENABLE_KPI_METRICS,
      linkTour: "".concat(APP_TASKS, "/tasks")
    }]
  }, {
    title: 'Invite your team',
    key: 'INVITE_TEAM',
    icon: 'emailOutgoing',
    iconColor: 'bloobirds',
    goals: [{
      label: 'Start with the first invitation',
      key: UserHelperKeys.INVITE_TEAM,
      linkHowTo: 'https://support.bloobirds.com/hc/en-us/articles/4837383989916-Sales-Team',
      linkYoutube: 'https://www.youtube.com/watch?v=StU7bJPvPxs'
    }]
  }];
};

var MIXPANEL_EVENTS = Object.freeze({
  SET_CADENCE_IMPORT_BULK_ACTION_CLICKED_ON_: 'SET_CADENCE_IMPORT_BULK_ACTION_CLICKED_ON_',
  SET_CADENCE_BASIC_BULK_ACTION_CLICKED_ON_: 'SET_CADENCE_BASIC_BULK_ACTION_CLICKED_ON_',
  STOP_CADENCE_IMPORT_BULK_ACTION_CLICKED_ON_: 'STOP_CADENCE_IMPORT_BULK_ACTION_CLICKED_ON_',
  STOP_CADENCE_BASIC_BULK_ACTION_CLICKED_ON_: 'STOP_CADENCE_BASIC_BULK_ACTION_CLICKED_ON_',
  REASSIGN_IMPORT_BULK_ACTION_CLICKED_ON_: 'REASSIGN_IMPORT_BULK_ACTION_CLICKED_ON_',
  REASSIGN_BASIC_BULK_ACTION_CLICKED_ON_: 'REASSIGN_BASIC_BULK_ACTION_CLICKED_ON_',
  //Change and open bubble/sidepeek menu
  CHANGE_TO_SIDEPEEK_VIEW: 'CHANGE_TO_SIDEPEEK_VIEW',
  CHANGE_TO_BUBBLE_VIEW: 'CHANGE_TO_BUBBLE_VIEW',
  MINIMIZE_BUBBLE_MENU: 'CLOSE_BUBBLE_MENU',
  MINIMIZE_SIDEPEEK_MENU: 'CLOSE_SIDEPEEK_MENU',
  MAXIMIZE_BUBBLE_VIEW: 'OPEN_BUBBLE_MENU',
  MAXIMIZE_SIDEPEEK_VIEW: 'OPEN_SIDEPEEK_MENU'
});

var NotificationsCategory;
(function (NotificationsCategory) {
  NotificationsCategory["UPDATES"] = "UPDATES";
  NotificationsCategory["INBOUND"] = "INBOUND";
  NotificationsCategory["EMAIL_TRACKING"] = "EMAIL_TRACKING";
  NotificationsCategory["CALLS"] = "CALLS";
  NotificationsCategory["REMINDERS"] = "REMINDERS";
  NotificationsCategory["INSIGHTS"] = "INSIGHTS";
})(NotificationsCategory || (NotificationsCategory = {}));
var NotificationsTypes;
(function (NotificationsTypes) {
  NotificationsTypes["PAGE_VIEW"] = "PAGE_VIEW";
  NotificationsTypes["NEW_EMAIL"] = "NEW_EMAIL";
  NotificationsTypes["NEW_LINKEDIN"] = "NEW_LINKEDIN";
  NotificationsTypes["NEW_INBOUND"] = "NEW_INBOUND";
  NotificationsTypes["NEW_INBOUND_LEAD"] = "NEW_INBOUND_LEAD";
  NotificationsTypes["MISSED_CALL_LEAD"] = "MISSED_CALL_LEAD";
  NotificationsTypes["MISSED_CALL_UNKNOWN"] = "MISSED_CALL_UNKNOWN";
  NotificationsTypes["REPORT_CALL"] = "REPORT_CALL";
  NotificationsTypes["EMAIL_CLICKED"] = "EMAIL_CLICKED";
  NotificationsTypes["EMAIL_OPENED"] = "EMAIL_OPENED";
  NotificationsTypes["INFORMATION"] = "INFORMATION";
  NotificationsTypes["ADVISE"] = "ADVISE";
  NotificationsTypes["IMPORT_FAILED"] = "IMPORT_FAILED";
  NotificationsTypes["IMPORT_COMPLETED"] = "IMPORT_COMPLETED";
  NotificationsTypes["IMPORT_COMPLETED_WITH_WARNINGS"] = "IMPORT_COMPLETED_WITH_WARNINGS";
  NotificationsTypes["ACCOUNT_STOPPED"] = "ACCOUNT_STOPPED";
  NotificationsTypes["MEETING_DONE"] = "MEETING_DONE";
  NotificationsTypes["MEETING_ACCEPTED"] = "MEETING_ACCEPTED";
  NotificationsTypes["MEETING_DELETED"] = "MEETING_DELETED";
  NotificationsTypes["MEETING_CANCELLED"] = "MEETING_CANCELLED";
  NotificationsTypes["MEETING_RESCHEDULED"] = "MEETING_RESCHEDULED";
  NotificationsTypes["CADENCE_ENDED"] = "CADENCE_ENDED";
  NotificationsTypes["COMPANY_ASSIGNED"] = "COMPANY_ASSIGNED";
  NotificationsTypes["LEAD_ASSIGNED"] = "LEAD_ASSIGNED";
  NotificationsTypes["WORKFLOWS"] = "WORKFLOWS";
  NotificationsTypes["RELATED_COMPANY_MEETING"] = "RELATED_COMPANY_MEETING";
  NotificationsTypes["RELATED_COMPANY_STATUS_ACCOUNT"] = "RELATED_COMPANY_STATUS_ACCOUNT";
  NotificationsTypes["RELATED_COMPANY_STATUS_CLIENT"] = "RELATED_COMPANY_STATUS_CLIENT";
  NotificationsTypes["RELATED_COMPANIES_OPPORTUNITY"] = "RELATED_COMPANIES_OPPORTUNITY";
  NotificationsTypes["RELATED_COMPANY_ACTIVITY_INBOUND"] = "RELATED_COMPANY_ACTIVITY_INBOUND";
  NotificationsTypes["RELATED_COMPANY_LEAD_INBOUND"] = "RELATED_COMPANY_LEAD_INBOUND";
})(NotificationsTypes || (NotificationsTypes = {}));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var magicFilterORs = function magicFilterORs(bobjectType) {
  var _ref2, _ref4, _ref5, _ref6, _ref7;
  return [_defineProperty({}, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, [ACTIVITY_TYPES_VALUES_LOGIC_ROLE.MEETING, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.INBOUND]), (_ref2 = {}, _defineProperty(_ref2, ACTIVITY_FIELDS_LOGIC_ROLE.ATTACHED_FILES, '__MATCH_FULL_ROWS__'), _defineProperty(_ref2, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.EMAIL), _ref2), _objectSpread(_defineProperty({}, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, 'ACTIVITY__TYPE__STATUS'), bobjectType !== BobjectTypes.Opportunity ? _defineProperty({}, ACTIVITY_FIELDS_LOGIC_ROLE.OPPORTUNITY, '__MATCH_FULL_ROWS__') : {}), (_ref4 = {}, _defineProperty(_ref4, ACTIVITY_FIELDS_LOGIC_ROLE.DIRECTION, DIRECTION_VALUES_LOGIC_ROLE.INCOMING), _defineProperty(_ref4, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.EMAIL), _ref4), (_ref5 = {}, _defineProperty(_ref5, ACTIVITY_FIELDS_LOGIC_ROLE.DIRECTION, DIRECTION_VALUES_LOGIC_ROLE.OUTGOING), _defineProperty(_ref5, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.CALL), _defineProperty(_ref5, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_RESULT, CALL_RESULTS_LOGIC_ROLE.CORRECT_CONTACT), _ref5), (_ref6 = {}, _defineProperty(_ref6, ACTIVITY_FIELDS_LOGIC_ROLE.DIRECTION, DIRECTION_VALUES_LOGIC_ROLE.OUTGOING), _defineProperty(_ref6, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.CALL), _defineProperty(_ref6, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_DURATION, {
    query: {
      gte: 60
    },
    searchMode: 'RANGE__SEARCH'
  }), _ref6), (_ref7 = {}, _defineProperty(_ref7, ACTIVITY_FIELDS_LOGIC_ROLE.DIRECTION, DIRECTION_VALUES_LOGIC_ROLE.INCOMING), _defineProperty(_ref7, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_DURATION, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.CALL), _defineProperty(_ref7, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_DURATION, {
    query: {
      gte: 60
    },
    searchMode: 'RANGE__SEARCH'
  }), _ref7), _defineProperty({}, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.NOTE)].filter(Boolean);
};
var BulkActions;
(function (BulkActions) {
  BulkActions["CREATE"] = "CREATE";
  BulkActions["UPDATE"] = "UPDATE";
  BulkActions["DELETE"] = "DELETE";
  BulkActions["RESYNC"] = "RESYNC";
  BulkActions["START_CADENCE"] = "START_CADENCE";
  BulkActions["STOP_CADENCE"] = "STOP_CADENCE";
})(BulkActions || (BulkActions = {}));
var TypeSearch;
(function (TypeSearch) {
  TypeSearch["SEARCH"] = "search";
  TypeSearch["AGGREGATION"] = "aggregation";
})(TypeSearch || (TypeSearch = {}));

var SalesforceTabs;
(function (SalesforceTabs) {
  SalesforceTabs["HOME"] = "home";
  SalesforceTabs["INBOX"] = "inbox";
  SalesforceTabs["OUTBOX"] = "outbox";
  SalesforceTabs["PIPELINE"] = "pipeline";
  SalesforceTabs["TASKS"] = "tasks";
  SalesforceTabs["MEETINGS"] = "meetings";
  SalesforceTabs["INACTIVE"] = "inactive";
  SalesforceTabs["NURTURING"] = "nurturing";
})(SalesforceTabs || (SalesforceTabs = {}));
var SalesforceTabsIcon;
(function (SalesforceTabsIcon) {
  SalesforceTabsIcon["HOME"] = "home";
  SalesforceTabsIcon["INBOX"] = "inbox";
  SalesforceTabsIcon["OUTBOX"] = "outbox";
  SalesforceTabsIcon["TASKS"] = "checkDouble";
  SalesforceTabsIcon["PIPELINE"] = "relatedCompanyLead";
  SalesforceTabsIcon["MEETINGS"] = "calendar";
  SalesforceTabsIcon["INACTIVE"] = "alertTriangle";
  SalesforceTabsIcon["NURTURING"] = "refresh";
})(SalesforceTabsIcon || (SalesforceTabsIcon = {}));

var SmartEmailTab;
(function (SmartEmailTab) {
  SmartEmailTab["PREVIEW"] = "PREVIEW";
  SmartEmailTab["PAST_ACTIVITY"] = "PAST_ACTIVITY";
  SmartEmailTab["CLOSED_DEALS"] = "CLOSED_DEALS";
  SmartEmailTab["TEMPLATES"] = "TEMPLATES";
  SmartEmailTab["SUGGESTIONS"] = "SUGGESTIONS";
  SmartEmailTab["CREATE_TASK"] = "CREATE_TASK";
  SmartEmailTab["CREATE_LEAD"] = "CREATE_LEAD";
  SmartEmailTab["CALENDAR"] = "CALENDAR";
})(SmartEmailTab || (SmartEmailTab = {}));
var SimilarDealsFields;
(function (SimilarDealsFields) {
  SimilarDealsFields["CONTACT"] = "contact";
  SimilarDealsFields["ACCOUNT_EXECUTIVE"] = "accountExecutive";
  SimilarDealsFields["CLOSE_DATE"] = "closeDate";
  SimilarDealsFields["CLIENT_DATE"] = "clientDate";
  SimilarDealsFields["AMOUNT"] = "amount";
  SimilarDealsFields["LINKEDIN_URL"] = "linkedinUrl";
})(SimilarDealsFields || (SimilarDealsFields = {}));
var SimilarDealsFieldsLabels;
(function (SimilarDealsFieldsLabels) {
  SimilarDealsFieldsLabels["contact"] = "Contact";
  SimilarDealsFieldsLabels["accountExecutive"] = "Account Executive";
  SimilarDealsFieldsLabels["closeDate"] = "Close date";
  SimilarDealsFieldsLabels["clientDate"] = "Client date";
  SimilarDealsFieldsLabels["amount"] = "Amount";
})(SimilarDealsFieldsLabels || (SimilarDealsFieldsLabels = {}));
var DateFilterValues;
(function (DateFilterValues) {
  DateFilterValues["LAST_30_DAYS"] = "last_30_days";
  DateFilterValues["LAST_90_DAYS"] = "last_90_days";
  DateFilterValues["LAST_180_DAYS"] = "last_180_days";
  DateFilterValues["LAST_YEAR"] = "last_year";
  DateFilterValues["ALL_TIME"] = "all_time";
})(DateFilterValues || (DateFilterValues = {}));

var TEMPLATE_TYPES;
(function (TEMPLATE_TYPES) {
  TEMPLATE_TYPES["SNIPPET"] = "SNIPPET";
  TEMPLATE_TYPES["PITCH"] = "PITCH";
  TEMPLATE_TYPES["EMAIL"] = "EMAIL";
  TEMPLATE_TYPES["LINKEDIN_MESSAGE"] = "LINKEDIN_MESSAGE";
  TEMPLATE_TYPES["LINKEDIN"] = "LINKEDIN_MESSAGE";
  TEMPLATE_TYPES["QUALIFYING_QUESTION"] = "QUALIFYING_QUESTION";
})(TEMPLATE_TYPES || (TEMPLATE_TYPES = {}));
var QQ_TYPES = Object.freeze({
  GLOBAL_PICKLIST: 'GLOBAL_PICKLIST',
  MULTI_GLOBAL_PICKLIST: 'MULTI_GLOBAL_PICKLIST',
  TEXT: 'TEXT'
});
var QQ_TYPES_COPIES = Object.freeze({
  GLOBAL_PICKLIST: 'Picklist',
  MULTI_GLOBAL_PICKLIST: 'Multi Picklist',
  TEXT: 'Text'
});
var TEMPLATE_TYPES_COPIES = Object.freeze({
  PITCH: 'Pitch',
  EMAIL: 'Email',
  LINKEDIN_MESSAGE: 'Linkedin',
  LINKEDIN: 'Linkedin',
  QUALIFYING_QUESTION: 'qualifying question'
});
var TEMPLATE_TYPES_ICONS = Object.freeze({
  PITCH: 'alignLeft',
  EMAIL: 'mail',
  LINKEDIN_MESSAGE: 'linkedin',
  LINKEDIN: 'linkedin',
  QUALIFYING_QUESTION: 'chat'
});
var FORM_MODES = Object.freeze({
  EDITION: 'EDITION',
  CREATION: 'CREATION',
  CLONE: 'CLONE'
});
var TemplateStage;
(function (TemplateStage) {
  TemplateStage["Prospecting"] = "PROSPECT";
  TemplateStage["Sales"] = "SALES";
  TemplateStage["All"] = "ALL";
})(TemplateStage || (TemplateStage = {}));

var DialerType;
(function (DialerType) {
  DialerType["AIRCALL_DIALER"] = "AIRCALL_DIALER";
  DialerType["BLOOBIRDS_DIALER"] = "BLOOBIRDS_DIALER";
  DialerType["JUST_CALL_DIALER"] = "JUST_CALL_DIALER";
})(DialerType || (DialerType = {}));
var UserType;
(function (UserType) {
  UserType["LICENSE_USER"] = "LICENSE_USER";
  UserType["SUPPORT_USER"] = "SUPPORT_USER";
  UserType["FREE_USER"] = "FREE_USER";
})(UserType || (UserType = {}));
var UserRole;
(function (UserRole) {
  UserRole["GLOBAL_ADMIN"] = "GLOBAL_ADMIN";
  UserRole["ACCOUNT_ADMIN"] = "ACCOUNT_ADMIN";
  UserRole["ACCOUNT_USER"] = "ACCOUNT_USER";
  UserRole["ACCOUNT_DEV"] = "ACCOUNT_DEV";
  UserRole["GLOBAL_DEV"] = "GLOBAL_DEV";
})(UserRole || (UserRole = {}));
var UserPermission;
(function (UserPermission) {
  UserPermission["VIEW_INBOUND_TAB"] = "VIEW_INBOUND_TAB";
  UserPermission["VIEW_INBOX"] = "VIEW_INBOX";
  UserPermission["VIEW_ADD_QC_TAB"] = "VIEW_ADD_QC_TAB";
  UserPermission["VIEW_ASSIGN_TAB"] = "VIEW_ASSIGN_TAB";
  UserPermission["VIEW_ADD_LEADS_TAB"] = "VIEW_ADD_LEADS_TAB";
  UserPermission["VIEW_PROSPECT_TAB"] = "VIEW_PROSPECT_TAB";
  UserPermission["VIEW_SCHEDULED_TAB"] = "VIEW_SCHEDULED_TAB";
  UserPermission["VIEW_MEETING_TAB"] = "VIEW_MEETING_TAB";
  UserPermission["VIEW_SALES_TAB"] = "VIEW_SALES_TAB";
  UserPermission["EDIT_ALL"] = "EDIT_ALL";
  UserPermission["VIEW_DASHBOARDS_TAB"] = "VIEW_DASHBOARDS_TAB";
  UserPermission["VIEW_OUTBOX_TAB"] = "VIEW_OUTBOX_TAB";
  UserPermission["BULK_ACTIONS"] = "BULK_ACTIONS";
  UserPermission["DOWNLOAD_LIST"] = "DOWNLOAD_LIST";
  UserPermission["VIEW_CADENCES"] = "VIEW_CADENCES";
})(UserPermission || (UserPermission = {}));

export { ACTIVITY_DIRECTION, ACTIVITY_FIELDS_LOGIC_ROLE, ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE, ACTIVITY_MODE, ACTIVITY_TYPES, ACTIVITY_TYPES_VALUES_LOGIC_ROLE, APP, APP_ACCOUNT, APP_ACCOUNT_CHROME_EXTENSION, APP_ACCOUNT_DIALERS, APP_ACCOUNT_DIALERS_AIRCALL, APP_ACCOUNT_DIALERS_AIRCALL_REDIRECT, APP_ACCOUNT_DIALERS_JUSTCALL, APP_ACCOUNT_DIALERS_TWILIO, APP_ACCOUNT_EMAILS, APP_ACCOUNT_FIELDS, APP_ACCOUNT_FIELD_DEPENDENCIES, APP_ACCOUNT_GENERAL_SETTINGS, APP_ACCOUNT_GLOBAL_PICKLISTS, APP_ACCOUNT_GROUPS, APP_ACCOUNT_INTEGRATION, APP_ACCOUNT_INTEGRATION_API_KEY, APP_ACCOUNT_INTEGRATION_DYNAMICS_ACTIONS, APP_ACCOUNT_INTEGRATION_DYNAMICS_CONNECT, APP_ACCOUNT_INTEGRATION_DYNAMICS_MAPPING, APP_ACCOUNT_INTEGRATION_DYNAMICS_SETTINGS, APP_ACCOUNT_INTEGRATION_DYNAMICS_SYNC_PICKLIST_MAPPINGS, APP_ACCOUNT_INTEGRATION_DYNAMICS_SYNC_STATUS, APP_ACCOUNT_INTEGRATION_DYNAMICS_TAB, APP_ACCOUNT_INTEGRATION_DYNAMICS_USERS, APP_ACCOUNT_INTEGRATION_HUBSPOT_CONNECT, APP_ACCOUNT_INTEGRATION_HUBSPOT_MAPPING, APP_ACCOUNT_INTEGRATION_HUBSPOT_OAUTH, APP_ACCOUNT_INTEGRATION_HUBSPOT_SYNC_SETTINGS, APP_ACCOUNT_INTEGRATION_HUBSPOT_SYNC_STATUS, APP_ACCOUNT_INTEGRATION_HUBSPOT_TAB, APP_ACCOUNT_INTEGRATION_HUBSPOT_USERS, APP_ACCOUNT_INTEGRATION_SALESFORCE, APP_ACCOUNT_INTEGRATION_SALESFORCE_CONNECT, APP_ACCOUNT_INTEGRATION_SALESFORCE_MAPPING, APP_ACCOUNT_INTEGRATION_SALESFORCE_MAPPING_NAME, APP_ACCOUNT_INTEGRATION_SALESFORCE_OAUTH, APP_ACCOUNT_INTEGRATION_SALESFORCE_SYNC_SETTINGS, APP_ACCOUNT_INTEGRATION_SALESFORCE_SYNC_STATUS, APP_ACCOUNT_INTEGRATION_SALESFORCE_TAB, APP_ACCOUNT_INTEGRATION_SALESFORCE_USERS, APP_ACCOUNT_INTEGRATION_VTIGER_ACTIONS, APP_ACCOUNT_INTEGRATION_VTIGER_CONNECT, APP_ACCOUNT_INTEGRATION_VTIGER_MAPPING, APP_ACCOUNT_INTEGRATION_VTIGER_SETTINGS, APP_ACCOUNT_INTEGRATION_VTIGER_SYNC_PICKLIST_MAPPINGS, APP_ACCOUNT_INTEGRATION_VTIGER_SYNC_STATUS, APP_ACCOUNT_INTEGRATION_VTIGER_TAB, APP_ACCOUNT_INTEGRATION_VTIGER_USERS, APP_ACCOUNT_NOTIFICATIONS, APP_ACCOUNT_SALES_TEAM, APP_ACCOUNT_VIEWS, APP_AUTOMATIONS, APP_CADENCES, APP_CADENCES_ANALYZE, APP_CADENCES_ANALYZE_CADENCE, APP_CADENCES_EDIT, APP_CADENCES_MANAGE, APP_CL, APP_CL_ACTIVITIES, APP_CL_ACTIVITIES_NEW_VIEW, APP_CL_COMPANIES, APP_CL_COMPANIES_COMPANY, APP_CL_COMPANIES_COMPANY_OPPORTUNITY, APP_CL_COMPANIES_COMPANY_TASK, APP_CL_COMPANIES_NEW_VIEW, APP_CL_IMPORT, APP_CL_IMPORT_HISTORY, APP_CL_LEADS, APP_CL_LEADS_LEAD, APP_CL_LEADS_NEW_VIEW, APP_CL_LISTS, APP_CL_MEETINGS, APP_CL_OPPORTUNITIES, APP_CL_OPPORTUNITIES_NEW_VIEW, APP_CL_OPPORTUNITIES_OPPORTUNITY, APP_CL_TASKS, APP_CL_TASKS_NEW_VIEW, APP_DASHBOARD, APP_DASHBOARD_PROSPECTING, APP_DASHBOARD_PROSPECTING_SECTION, APP_DASHBOARD_SALES, APP_DASHBOARD_SALES_SECTION, APP_MANAGEMENT, APP_MANAGEMENT_ACCOUNT, APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_BUYER_PERSONAS, APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_CADENCES, APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_CADENCES_EDIT, APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_SCENARIOS, APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_SINGLE_CADENCE, APP_MANAGEMENT_ACCOUNT_BUSINESS_ASSETS_TARGET_MARKET, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_DYNAMICS_TAB, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_CONNECT, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_MAPPING, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_OAUTH, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_SYNC_SETTINGS, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_SYNC_STATUS, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_TAB, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_HUBSPOT_USERS, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_CONNECT, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_MAPPING, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_OAUTH, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_SYNC_SETTINGS, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_SYNC_STATUS, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_TAB, APP_MANAGEMENT_ACCOUNT_CONFIGURATION_INTEGRATION_SALESFORCE_USERS, APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_DEPENDENCIES, APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_FIELDS, APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_GLOBAL_PICKLISTS, APP_MANAGEMENT_ACCOUNT_DATA_MANAGEMENT_GROUPS, APP_MANAGEMENT_ACCOUNT_DIALERS, APP_MANAGEMENT_ACCOUNT_DIALERS_AIRCALL, APP_MANAGEMENT_ACCOUNT_DIALERS_AIRCALL_REDIRECT, APP_MANAGEMENT_ACCOUNT_DIALERS_TWILIO, APP_MANAGEMENT_ACCOUNT_MESSAGING_EMAIL, APP_MANAGEMENT_ACCOUNT_MESSAGING_EMAIL_FORM, APP_MANAGEMENT_ACCOUNT_MESSAGING_LINKEDIN, APP_MANAGEMENT_ACCOUNT_MESSAGING_LINKEDIN_FORM, APP_MANAGEMENT_ACCOUNT_MESSAGING_PITCH, APP_MANAGEMENT_ACCOUNT_MESSAGING_PITCH_FORM, APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ, APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ_FORM, APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ_ONE, APP_MANAGEMENT_ACCOUNT_MESSAGING_QQ_SCORES, APP_MANAGEMENT_ACCOUNT_MESSAGING_SEGMENTATION, APP_MANAGEMENT_ACCOUNT_PREFERENCES_GENERAL_SETTINGS, APP_MANAGEMENT_ACCOUNT_PREFERENCES_NOTIFICATIONS, APP_MANAGEMENT_ACCOUNT_PREFERENCES_USERS, APP_MANAGEMENT_ACCOUNT_PREFERENCES_VIEWS, APP_MANAGEMENT_USER, APP_PLAYBOOK, APP_PLAYBOOK_BUYER_PERSONAS, APP_PLAYBOOK_CADENCES, APP_PLAYBOOK_CADENCES_EDIT, APP_PLAYBOOK_MESSAGING, APP_PLAYBOOK_MESSAGING_EMAIL, APP_PLAYBOOK_MESSAGING_EMAIL_FORM, APP_PLAYBOOK_MESSAGING_LINKEDIN, APP_PLAYBOOK_MESSAGING_LINKEDIN_FORM, APP_PLAYBOOK_MESSAGING_PITCH, APP_PLAYBOOK_MESSAGING_PITCH_FORM, APP_PLAYBOOK_MESSAGING_QQ, APP_PLAYBOOK_MESSAGING_QQ_FORM, APP_PLAYBOOK_MESSAGING_QQ_ONE, APP_PLAYBOOK_MESSAGING_QQ_SCORES, APP_PLAYBOOK_MESSAGING_SEGMENTATION, APP_PLAYBOOK_MESSAGING_WORKFLOWS, APP_PLAYBOOK_MESSAGING_WORKFLOWS_EDIT, APP_PLAYBOOK_PRODUCTS, APP_PLAYBOOK_PRODUCTS_CATEGORIES, APP_PLAYBOOK_SALES_PIPELINE, APP_PLAYBOOK_SCENARIOS, APP_PLAYBOOK_SINGLE_CADENCE, APP_PLAYBOOK_TARGET_MARKET, APP_SINGLE_CADENCE, APP_TASKS, APP_TASKS_ADD_QC, APP_TASKS_ASSIGN_QC, APP_TASKS_DONE, APP_TASKS_INBOUND, APP_TASKS_INBOUND_MQL, APP_TASKS_INBOUND_SAL, APP_TASKS_INBOX, APP_TASKS_INBOX_SECTION, APP_TASKS_OUTBOX, APP_TASKS_OUTBOX_SECTION, APP_TASKS_PROSPECTING, APP_TASKS_PROSPECTING_SECTION, APP_TASKS_SALES, APP_TASKS_SALES_SECTION, APP_TASKS_TASK, APP_TASKS_WELCOME, AVAILABLE_COMPANY_STATUS_LOGIC_ROLE, BOBJECT_TYPES, BOUNCED_EMAIL_VALUES_LOGIC_ROLE, BobjectTypes, BulkActions, CADENCE_TYPES_VALUES_LOGIC_ROLE, CALL_RESULTS_LOGIC_ROLE, COMPANY_FIELDS_LOGIC_ROLE, COMPANY_HIGH_PRIORITY_LOGIC_ROLE, COMPANY_OPT_OUT_LOGIC_ROLE, COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE, COMPANY_STAGE_LOGIC_ROLE, COMPANY_STATUS, COMPANY_STATUS_LOGIC_ROLE, ContactViewSubTab, ContactViewTab, CustomUserHelperKeys, DATA_SOURCES, DIRECTION_VALUES_LOGIC_ROLE, DateFilterValues, DialerType, Direction, EXTERNAL_ACTION, EXTERNAL_ACTION_CONFIRM_INVITATION, EXTERNAL_ACTION_REQUEST_RESET_PASSWORD, EXTERNAL_ACTION_RESET_PASSWORD, EXTERNAL_ACTION_SIGN_AS, EXTERNAL_ACTION_VALIDATE_EMAIL, ExtensionHelperKeys, FIELDS_LOGIC_ROLE, FORM_MODES, FilterType, GLOBAL_PICKLISTS, HOME, HUBSPOT, IAPP_INTEGRATIONS, IMPORT_THRESHOLD, IS_AUTOMATED_EMAIL_VALUES, IS_PINNED_VALUES_LOGIC_ROLE, LEAD_CADENCE_STOPPED_LOGIC_ROLE, LEAD_FIELDS_LOGIC_ROLE, LEAD_HIGH_PRIORITY_LOGIC_ROLE, LEAD_IS_MQL_OR_SAL_LOGIC_ROLE, LEAD_OPT_OUT_LOGIC_ROLE, LEAD_SALES_STATUS_VALUES_LOGIC_ROLE, LEAD_SOURCE_LOGIC_ROLES, LEAD_STAGE_LOGIC_ROLE, LEAD_STATUS, LEAD_STATUS_LOGIC_ROLE, LOGIN, MEETING_MAIN_TYPE_VALUES, MIXPANEL_EVENTS, MatchRows, MessagesEvents, NotificationsCategory, NotificationsTypes, OPPORTUNITY_FIELDS_LOGIC_ROLE, OPPORTUNITY_INFO_ACTIVITY_TYPE_VALUES_LOGIC_ROLE_NAME, OPPORTUNITY_LEADS_LOGIC_ROLES, OPPORTUNITY_OPT_OUT_LOGIC_ROLE, OPPORTUNITY_PRODUCT_FIELDS_LOGIC_ROLE, OPPORTUNITY_STATUS_LOGIC_ROLE, PITCH_DONE_VALUES_LOGIC_ROLE, PRIVACY_POLICY, PRODUCT_FIELDS_LOGIC_ROLE, PlaybookTab, PluralBobjectTypes, QQ_TYPES, QQ_TYPES_COPIES, REPORTED_VALUES_LOGIC_ROLE, RelativesDate, SALES_STATUS_VALUES_LOGIC_ROLES, STAGE_VALUES_LOGIC_ROLES, STATUS_VALUES_LOGIC_ROLES, SalesforceTabs, SalesforceTabsIcon, SearchMode, SearchType, SearchTypeByKey, SimilarDealsFields, SimilarDealsFieldsLabels, SingularFromPluralBobjectTypes, SmartEmailTab, TASK_ACTION, TASK_ACTION_VALUE, TASK_AUTOMATED_ERROR_LOGIC_ROLE, TASK_AUTOMATED_PAUSED_REASONS_LOGIC_ROLE, TASK_AUTOMATED_STATUS_LOGIC_ROLE, TASK_AUTOMATED_VALUE, TASK_FIELDS_LOGIC_ROLE, TASK_STATUS_VALUE_LOGIC_ROLE, TASK_TYPE, TEMPLATE_TYPES, TEMPLATE_TYPES_COPIES, TEMPLATE_TYPES_ICONS, TERMS_AND_CONDITIONS, TYPES_STATUS_VALUES_LOGIC_ROLE, TaskTypeName, TasksHookFamilies, TemplateStage, TypeSearch, UserHelperKeys, UserHelperTooltipsKeys, UserPermission, UserRole, UserType, activityUrl, bobjectUrl, cadenceEditUrl, cadenceEditUrlV2, companyIdUrl, companyTaskUrl, companyUrl, defaultSearchCompany, getAdminQuickStartGuideBlocks, getQuickStartGuideBlocks, integrationURLs, isBobject, leadTaskUrl, leadUrl, magicFilterORs, opportunityUrl, taskUrl, typeFilterConstants, workflowEditUrl };
